/**
 * Generated by "@vuepress/internal-site-data"
 */
export const siteData = {
  "title": "铁匠",
  "description": "golang java 技术 架构 微服务 云原生 铁匠",
  "base": "/",
  "headTags": [
    [
      "link",
      {
        "rel": "icon",
        "href": "/avatar.jpg"
      }
    ],
    [
      "meta",
      {
        "name": "apple-mobile-web-app-capable",
        "content": "yes"
      }
    ],
    [
      "meta",
      {
        "name": "apple-mobile-web-app-status-bar-style",
        "content": "black"
      }
    ],
    [
      "meta",
      {
        "name": "viewport",
        "content": "width=device-width,initial-scale=1,user-scalable=no"
      }
    ]
  ],
  "pages": [
    {
      "title": "golang 入门学习指南",
      "frontmatter": {
        "title": "golang 入门学习指南",
        "date": "2024-04-18T23:09:56.000Z",
        "permalink": "/go",
        "categories": [
          "go"
        ],
        "tags": [
          null
        ]
      },
      "regularPath": "/02.go/01.README.html",
      "relativePath": "02.go/01.README.md",
      "key": "v-4ad37bea",
      "path": "/go/",
      "headers": [
        {
          "level": 2,
          "title": "学习指南",
          "slug": "学习指南"
        },
        {
          "level": 2,
          "title": "学习 demo",
          "slug": "学习-demo"
        },
        {
          "level": 2,
          "title": "常用开源库",
          "slug": "常用开源库"
        },
        {
          "level": 2,
          "title": "测试",
          "slug": "测试"
        },
        {
          "level": 2,
          "title": "流行框架",
          "slug": "流行框架"
        }
      ]
    },
    {
      "title": "开源项目、博客、书籍整理",
      "frontmatter": {
        "title": "开源项目、博客、书籍整理",
        "date": "2020-10-25T00:00:00.000Z",
        "author": "FengJianxin",
        "sidebar": "auto",
        "categories": [
          "awesome"
        ],
        "location": "GuangZhou",
        "sticky": 1,
        "permalink": "/awesome",
        "tags": [
          null
        ]
      },
      "regularPath": "/01.%E6%94%B6%E8%97%8F/01.awesome.html",
      "relativePath": "01.收藏/01.awesome.md",
      "key": "v-5b74fcf9",
      "path": "/awesome/",
      "headers": [
        {
          "level": 2,
          "title": "博客、教程",
          "slug": "博客、教程"
        },
        {
          "level": 2,
          "title": "写作",
          "slug": "写作"
        },
        {
          "level": 2,
          "title": "开发工具",
          "slug": "开发工具"
        },
        {
          "level": 2,
          "title": "设计工具",
          "slug": "设计工具"
        },
        {
          "level": 2,
          "title": "开源工具",
          "slug": "开源工具"
        },
        {
          "level": 2,
          "title": "计算机基础",
          "slug": "计算机基础"
        },
        {
          "level": 2,
          "title": "数据库 & 缓存 & NoSql",
          "slug": "数据库-缓存-nosql"
        },
        {
          "level": 2,
          "title": "java",
          "slug": "java"
        },
        {
          "level": 2,
          "title": "python",
          "slug": "python"
        },
        {
          "level": 2,
          "title": "go",
          "slug": "go"
        },
        {
          "level": 2,
          "title": "web & nodejs",
          "slug": "web-nodejs"
        },
        {
          "level": 2,
          "title": "lua & OpenResty & nginx",
          "slug": "lua-openresty-nginx"
        },
        {
          "level": 2,
          "title": "消息中间件",
          "slug": "消息中间件"
        },
        {
          "level": 2,
          "title": "elk",
          "slug": "elk"
        },
        {
          "level": 2,
          "title": "APM",
          "slug": "apm"
        },
        {
          "level": 2,
          "title": "操作系统",
          "slug": "操作系统"
        },
        {
          "level": 2,
          "title": "运维",
          "slug": "运维"
        },
        {
          "level": 2,
          "title": "flutter",
          "slug": "flutter"
        },
        {
          "level": 2,
          "title": "IOT",
          "slug": "iot"
        },
        {
          "level": 2,
          "title": "架构",
          "slug": "架构"
        },
        {
          "level": 2,
          "title": "其他",
          "slug": "其他"
        }
      ]
    },
    {
      "title": "go-kit学习指南 - 基础概念和架构",
      "frontmatter": {
        "title": "go-kit学习指南 - 基础概念和架构",
        "date": "2024-04-18T23:22:55.000Z",
        "permalink": "/pages/40737e/",
        "categories": [
          "go"
        ],
        "tags": [
          "go-kit"
        ]
      },
      "regularPath": "/02.go/10.go-kit/01.quickstart.html",
      "relativePath": "02.go/10.go-kit/01.quickstart.md",
      "key": "v-9728a4ea",
      "path": "/pages/40737e/",
      "headers": [
        {
          "level": 2,
          "title": "介绍",
          "slug": "介绍"
        },
        {
          "level": 2,
          "title": "分层设计",
          "slug": "分层设计"
        },
        {
          "level": 2,
          "title": "实现步骤",
          "slug": "实现步骤"
        },
        {
          "level": 3,
          "title": "参考代码",
          "slug": "参考代码"
        },
        {
          "level": 3,
          "title": "启动服务",
          "slug": "启动服务"
        },
        {
          "level": 3,
          "title": "测试",
          "slug": "测试"
        }
      ]
    },
    {
      "title": "go-kit学习指南 - 多协议支持",
      "frontmatter": {
        "title": "go-kit学习指南 - 多协议支持",
        "date": "2024-04-19T00:41:30.000Z",
        "permalink": "/pages/efb886/",
        "categories": [
          "go"
        ],
        "tags": [
          "go-kit"
        ]
      },
      "regularPath": "/02.go/10.go-kit/02.protocol-support.html",
      "relativePath": "02.go/10.go-kit/02.protocol-support.md",
      "key": "v-b0c73eea",
      "path": "/pages/efb886/",
      "headers": [
        {
          "level": 2,
          "title": "多协议支持好处",
          "slug": "多协议支持好处"
        },
        {
          "level": 2,
          "title": "实现步骤",
          "slug": "实现步骤"
        },
        {
          "level": 3,
          "title": "安装 grpc 编译工具",
          "slug": "安装-grpc-编译工具"
        },
        {
          "level": 3,
          "title": "定义 protobuf 协议",
          "slug": "定义-protobuf-协议"
        },
        {
          "level": 3,
          "title": "编译protobuf",
          "slug": "编译protobuf"
        },
        {
          "level": 3,
          "title": "参考代码",
          "slug": "参考代码"
        },
        {
          "level": 3,
          "title": "启动服务",
          "slug": "启动服务"
        },
        {
          "level": 3,
          "title": "测试",
          "slug": "测试"
        }
      ]
    },
    {
      "title": "go-kit学习指南 - 中间件",
      "frontmatter": {
        "title": "go-kit学习指南 - 中间件",
        "date": "2024-04-19T00:41:30.000Z",
        "permalink": "/pages/d6f092/",
        "categories": [
          "go"
        ],
        "tags": [
          "go-kit"
        ]
      },
      "regularPath": "/02.go/10.go-kit/03.middleware.html",
      "relativePath": "02.go/10.go-kit/03.middleware.md",
      "key": "v-dd5133aa",
      "path": "/pages/d6f092/",
      "headers": [
        {
          "level": 2,
          "title": "介绍",
          "slug": "介绍"
        },
        {
          "level": 2,
          "title": "实现步骤",
          "slug": "实现步骤"
        },
        {
          "level": 3,
          "title": "参考代码",
          "slug": "参考代码"
        },
        {
          "level": 3,
          "title": "启动服务",
          "slug": "启动服务"
        },
        {
          "level": 3,
          "title": "测试",
          "slug": "测试"
        }
      ]
    },
    {
      "title": "go-kit开发微服务 - 服务注册与发现",
      "frontmatter": {
        "title": "go-kit开发微服务 - 服务注册与发现",
        "date": "2024-04-19T00:41:30.000Z",
        "permalink": "/pages/a15528/",
        "categories": [
          "go"
        ],
        "tags": [
          "go-kit"
        ]
      },
      "regularPath": "/02.go/10.go-kit/04.discovery.html",
      "relativePath": "02.go/10.go-kit/04.discovery.md",
      "key": "v-6a920f57",
      "path": "/pages/a15528/",
      "headers": [
        {
          "level": 2,
          "title": "介绍",
          "slug": "介绍"
        },
        {
          "level": 2,
          "title": "实现步骤",
          "slug": "实现步骤"
        },
        {
          "level": 3,
          "title": "准备工作",
          "slug": "准备工作"
        },
        {
          "level": 3,
          "title": "服务注册（服务端）",
          "slug": "服务注册-服务端"
        },
        {
          "level": 3,
          "title": "服务发现（客户端）",
          "slug": "服务发现-客户端"
        }
      ]
    },
    {
      "title": "java api 文档",
      "frontmatter": {
        "title": "java api 文档",
        "date": "2020-06-16T23:36:05.000Z",
        "permalink": "/java",
        "categories": [
          "java"
        ],
        "tags": [
          "doc"
        ]
      },
      "regularPath": "/03.java/01.README.html",
      "relativePath": "03.java/01.README.md",
      "key": "v-5783042a",
      "path": "/java/"
    },
    {
      "title": "Lambda表达式与函数式接口",
      "frontmatter": {
        "title": "Lambda表达式与函数式接口",
        "date": "2019-08-12T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "java8"
        ],
        "categories": [
          "java"
        ],
        "location": "GuangZhou",
        "permalink": "/pages/581190/"
      },
      "regularPath": "/03.java/10.%E7%89%88%E6%9C%AC%E7%89%B9%E6%80%A7/01.java8/01.lambda-function.html",
      "relativePath": "03.java/10.版本特性/01.java8/01.lambda-function.md",
      "key": "v-59ec457e",
      "path": "/pages/581190/",
      "headers": [
        {
          "level": 2,
          "title": "Lambda表达式",
          "slug": "lambda表达式"
        },
        {
          "level": 2,
          "title": "函数式接口",
          "slug": "函数式接口"
        },
        {
          "level": 2,
          "title": "示例",
          "slug": "示例"
        }
      ]
    },
    {
      "title": "新的Date&Time API",
      "frontmatter": {
        "title": "新的Date&Time API",
        "date": "2019-08-15T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "java8"
        ],
        "categories": [
          "java"
        ],
        "location": "GuangZhou",
        "permalink": "/pages/8a3a67/"
      },
      "regularPath": "/03.java/10.%E7%89%88%E6%9C%AC%E7%89%B9%E6%80%A7/01.java8/02.date.html",
      "relativePath": "03.java/10.版本特性/01.java8/02.date.md",
      "key": "v-b91e7d08",
      "path": "/pages/8a3a67/",
      "headers": [
        {
          "level": 2,
          "title": "api",
          "slug": "api"
        },
        {
          "level": 2,
          "title": "示例",
          "slug": "示例"
        }
      ]
    },
    {
      "title": "Stream（流）",
      "frontmatter": {
        "title": "Stream（流）",
        "date": "2019-08-12T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "java8"
        ],
        "categories": [
          "java"
        ],
        "location": "GuangZhou",
        "permalink": "/pages/1a3449/"
      },
      "regularPath": "/03.java/10.%E7%89%88%E6%9C%AC%E7%89%B9%E6%80%A7/01.java8/04.stream.html",
      "relativePath": "03.java/10.版本特性/01.java8/04.stream.md",
      "key": "v-6e39319c",
      "path": "/pages/1a3449/",
      "headers": [
        {
          "level": 2,
          "title": "什么是Stream",
          "slug": "什么是stream"
        },
        {
          "level": 2,
          "title": "创建流",
          "slug": "创建流"
        },
        {
          "level": 2,
          "title": "处理流",
          "slug": "处理流"
        },
        {
          "level": 3,
          "title": "筛选与切片",
          "slug": "筛选与切片"
        },
        {
          "level": 3,
          "title": "映射 - 将数据映射成其他类型的数据",
          "slug": "映射-将数据映射成其他类型的数据"
        },
        {
          "level": 3,
          "title": "排序",
          "slug": "排序"
        },
        {
          "level": 2,
          "title": "终止流",
          "slug": "终止流"
        },
        {
          "level": 3,
          "title": "匹配",
          "slug": "匹配"
        },
        {
          "level": 3,
          "title": "查找",
          "slug": "查找"
        },
        {
          "level": 3,
          "title": "统计",
          "slug": "统计"
        },
        {
          "level": 3,
          "title": "迭代",
          "slug": "迭代"
        },
        {
          "level": 3,
          "title": "聚合",
          "slug": "聚合"
        },
        {
          "level": 3,
          "title": "收集",
          "slug": "收集"
        },
        {
          "level": 2,
          "title": "示例",
          "slug": "示例"
        }
      ]
    },
    {
      "title": "optional",
      "frontmatter": {
        "title": "optional",
        "date": "2020-06-16T23:36:05.000Z",
        "permalink": "/pages/191279/",
        "categories": [
          "java",
          "java8"
        ],
        "tags": [
          null
        ]
      },
      "regularPath": "/03.java/10.%E7%89%88%E6%9C%AC%E7%89%B9%E6%80%A7/01.java8/05.optional.html",
      "relativePath": "03.java/10.版本特性/01.java8/05.optional.md",
      "key": "v-9b01d8c4",
      "path": "/pages/191279/"
    },
    {
      "title": "JVM 结构体系",
      "frontmatter": {
        "title": "JVM 结构体系",
        "date": "2019-09-15T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "jvm"
        ],
        "categories": [
          "java"
        ],
        "location": "GuangZhou",
        "permalink": "/pages/fc50f5/"
      },
      "regularPath": "/03.java/20.jvm/01.jvm.html",
      "relativePath": "03.java/20.jvm/01.jvm.md",
      "key": "v-40aa688b",
      "path": "/pages/fc50f5/"
    },
    {
      "title": "JVM 内存区域划分",
      "frontmatter": {
        "title": "JVM 内存区域划分",
        "date": "2019-09-15T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "jvm"
        ],
        "categories": [
          "java"
        ],
        "location": "GuangZhou",
        "permalink": "/pages/9e1ec7/"
      },
      "regularPath": "/03.java/20.jvm/02.jvm-runtime-data-area.html",
      "relativePath": "03.java/20.jvm/02.jvm-runtime-data-area.md",
      "key": "v-7cfced2a",
      "path": "/pages/9e1ec7/",
      "headers": [
        {
          "level": 2,
          "title": "Reference",
          "slug": "reference"
        },
        {
          "level": 2,
          "title": "堆（Heap）",
          "slug": "堆-heap"
        },
        {
          "level": 2,
          "title": "直接内存（堆外内存）",
          "slug": "直接内存-堆外内存"
        },
        {
          "level": 2,
          "title": "方法区（Method-Area / Non-Heap）",
          "slug": "方法区-method-area-non-heap"
        },
        {
          "level": 3,
          "title": "运行时常量池（Runtime Constant Pool）",
          "slug": "运行时常量池-runtime-constant-pool"
        },
        {
          "level": 2,
          "title": "程序计数器（Program Counter Register）",
          "slug": "程序计数器-program-counter-register"
        },
        {
          "level": 2,
          "title": "虚拟机栈（VM Stack）",
          "slug": "虚拟机栈-vm-stack"
        },
        {
          "level": 2,
          "title": "本地方法栈（Native Method Stack）",
          "slug": "本地方法栈-native-method-stack"
        }
      ]
    },
    {
      "title": "JVM 垃圾收集",
      "frontmatter": {
        "title": "JVM 垃圾收集",
        "date": "2019-11-11T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "jvm"
        ],
        "categories": [
          "java"
        ],
        "location": "GuangZhou",
        "permalink": "/pages/57792d/"
      },
      "regularPath": "/03.java/20.jvm/03.gc.html",
      "relativePath": "03.java/20.jvm/03.gc.md",
      "key": "v-479feea1",
      "path": "/pages/57792d/",
      "headers": [
        {
          "level": 2,
          "title": "参考",
          "slug": "参考"
        },
        {
          "level": 2,
          "title": "垃圾回收区域",
          "slug": "垃圾回收区域"
        },
        {
          "level": 2,
          "title": "判断哪些对象可以回收",
          "slug": "判断哪些对象可以回收"
        },
        {
          "level": 2,
          "title": "垃圾回收算法",
          "slug": "垃圾回收算法"
        },
        {
          "level": 2,
          "title": "分代垃圾回收",
          "slug": "分代垃圾回收"
        },
        {
          "level": 2,
          "title": "垃圾对象转移和收集过程",
          "slug": "垃圾对象转移和收集过程"
        },
        {
          "level": 2,
          "title": "垃圾收集器",
          "slug": "垃圾收集器"
        },
        {
          "level": 3,
          "title": "Serial",
          "slug": "serial"
        },
        {
          "level": 3,
          "title": "Serial Old",
          "slug": "serial-old"
        },
        {
          "level": 3,
          "title": "ParNew",
          "slug": "parnew"
        },
        {
          "level": 3,
          "title": "Parallel Scavenge",
          "slug": "parallel-scavenge"
        },
        {
          "level": 3,
          "title": "Parallel Old",
          "slug": "parallel-old"
        },
        {
          "level": 3,
          "title": "CMS",
          "slug": "cms"
        },
        {
          "level": 3,
          "title": "G1",
          "slug": "g1"
        },
        {
          "level": 3,
          "title": "常用GC收集器组合",
          "slug": "常用gc收集器组合"
        }
      ]
    },
    {
      "title": "JVM 参数配置",
      "frontmatter": {
        "title": "JVM 参数配置",
        "date": "2019-09-17T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "jvm"
        ],
        "categories": [
          "java"
        ],
        "location": "GuangZhou",
        "permalink": "/pages/eeb95f/"
      },
      "regularPath": "/03.java/20.jvm/04.jvm-option.html",
      "relativePath": "03.java/20.jvm/04.jvm-option.md",
      "key": "v-68d0614e",
      "path": "/pages/eeb95f/",
      "headers": [
        {
          "level": 2,
          "title": "参数说明",
          "slug": "参数说明"
        },
        {
          "level": 2,
          "title": "推荐配置",
          "slug": "推荐配置"
        },
        {
          "level": 2,
          "title": "查看进程启动参数",
          "slug": "查看进程启动参数"
        },
        {
          "level": 2,
          "title": "配置说明",
          "slug": "配置说明"
        },
        {
          "level": 3,
          "title": "系统参数",
          "slug": "系统参数"
        },
        {
          "level": 3,
          "title": "堆内存参数",
          "slug": "堆内存参数"
        },
        {
          "level": 3,
          "title": "堆外内存参数",
          "slug": "堆外内存参数"
        },
        {
          "level": 3,
          "title": "GC配置参数",
          "slug": "gc配置参数"
        },
        {
          "level": 3,
          "title": "G1 配置参数",
          "slug": "g1-配置参数"
        },
        {
          "level": 3,
          "title": "JVM 日志相关参数",
          "slug": "jvm-日志相关参数"
        }
      ]
    },
    {
      "title": "JVM 监控分析工具",
      "frontmatter": {
        "title": "JVM 监控分析工具",
        "date": "2019-09-15T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "jvm"
        ],
        "categories": [
          "java"
        ],
        "location": "GuangZhou",
        "permalink": "/pages/d0ff21/"
      },
      "regularPath": "/03.java/20.jvm/05.tools.html",
      "relativePath": "03.java/20.jvm/05.tools.md",
      "key": "v-3885166a",
      "path": "/pages/d0ff21/",
      "headers": [
        {
          "level": 2,
          "title": "jps",
          "slug": "jps"
        },
        {
          "level": 2,
          "title": "jstat",
          "slug": "jstat"
        },
        {
          "level": 3,
          "title": "gcutil: 虚拟机统计信息监控工具",
          "slug": "gcutil-虚拟机统计信息监控工具"
        },
        {
          "level": 2,
          "title": "jinfo: java配置信息查看工具",
          "slug": "jinfo-java配置信息查看工具"
        },
        {
          "level": 2,
          "title": "jmap: java内存快照监控工具",
          "slug": "jmap-java内存快照监控工具"
        },
        {
          "level": 2,
          "title": "jhat: 虚拟机堆转储快照分析工具",
          "slug": "jhat-虚拟机堆转储快照分析工具"
        },
        {
          "level": 2,
          "title": "jstack: java堆栈跟踪工具",
          "slug": "jstack-java堆栈跟踪工具"
        },
        {
          "level": 2,
          "title": "jcmd: 其他监控命令（jps、jstat、jmap、jstack 等）集合",
          "slug": "jcmd-其他监控命令-jps、jstat、jmap、jstack-等-集合"
        }
      ]
    },
    {
      "title": "JVM 类加载器过程",
      "frontmatter": {
        "title": "JVM 类加载器过程",
        "date": "2021-11-07T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "jvm"
        ],
        "categories": [
          "java"
        ],
        "location": "GuangZhou",
        "permalink": "/pages/2204ba/"
      },
      "regularPath": "/03.java/20.jvm/07.class-loader.html",
      "relativePath": "03.java/20.jvm/07.class-loader.md",
      "key": "v-129e79de",
      "path": "/pages/2204ba/",
      "headers": [
        {
          "level": 2,
          "title": "类加载过程",
          "slug": "类加载过程"
        },
        {
          "level": 2,
          "title": "双亲委派",
          "slug": "双亲委派"
        },
        {
          "level": 2,
          "title": "自定义 Classloader",
          "slug": "自定义-classloader"
        },
        {
          "level": 2,
          "title": "应用",
          "slug": "应用"
        }
      ]
    },
    {
      "title": "方法引用",
      "frontmatter": {
        "title": "方法引用",
        "date": "2019-08-12T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "java8"
        ],
        "categories": [
          "java"
        ],
        "location": "GuangZhou",
        "permalink": "/pages/94fd66/"
      },
      "regularPath": "/03.java/10.%E7%89%88%E6%9C%AC%E7%89%B9%E6%80%A7/01.java8/03.method-ref.html",
      "relativePath": "03.java/10.版本特性/01.java8/03.method-ref.md",
      "key": "v-2ddbe08c",
      "path": "/pages/94fd66/"
    },
    {
      "title": "netty介绍",
      "frontmatter": {
        "title": "netty介绍",
        "date": "2018-12-10T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "socket",
          "io",
          "netty"
        ],
        "categories": [
          "java"
        ],
        "location": "GuangZhou",
        "permalink": "/pages/32a147/"
      },
      "regularPath": "/03.java/30.%E7%BD%91%E7%BB%9C%E7%BC%96%E7%A8%8B/02.netty.html",
      "relativePath": "03.java/30.网络编程/02.netty.md",
      "key": "v-d5bb5e54",
      "path": "/pages/32a147/",
      "headers": [
        {
          "level": 2,
          "title": "优点",
          "slug": "优点"
        },
        {
          "level": 2,
          "title": "沾包、拆包",
          "slug": "沾包、拆包"
        },
        {
          "level": 2,
          "title": "编解码",
          "slug": "编解码"
        },
        {
          "level": 2,
          "title": "使用",
          "slug": "使用"
        }
      ]
    },
    {
      "title": "并发编程三大特性",
      "frontmatter": {
        "title": "并发编程三大特性",
        "date": "2019-03-10T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "并发编程"
        ],
        "categories": [
          "java"
        ],
        "permalink": "/pages/669a06/"
      },
      "regularPath": "/03.java/40.%E5%B9%B6%E5%8F%91%E7%BC%96%E7%A8%8B/01.index.html",
      "relativePath": "03.java/40.并发编程/01.index.md",
      "key": "v-153b23a3",
      "path": "/pages/669a06/",
      "headers": [
        {
          "level": 2,
          "title": "可见性",
          "slug": "可见性"
        },
        {
          "level": 2,
          "title": "顺序性",
          "slug": "顺序性"
        },
        {
          "level": 2,
          "title": "原子性",
          "slug": "原子性"
        },
        {
          "level": 2,
          "title": "参考",
          "slug": "参考"
        }
      ]
    },
    {
      "title": "线程的基本概念",
      "frontmatter": {
        "title": "线程的基本概念",
        "date": "2022-11-05T22:18:12.000Z",
        "permalink": "/pages/0b1de7/",
        "tags": [
          "并发编程"
        ],
        "categories": [
          "java"
        ]
      },
      "regularPath": "/03.java/40.%E5%B9%B6%E5%8F%91%E7%BC%96%E7%A8%8B/02.thread-Introduction.html",
      "relativePath": "03.java/40.并发编程/02.thread-Introduction.md",
      "key": "v-6d2822ea",
      "path": "/pages/0b1de7/",
      "headers": [
        {
          "level": 2,
          "title": "java 线程生命周期",
          "slug": "java-线程生命周期"
        }
      ]
    },
    {
      "title": "自己动手写一个 java 热加载插件",
      "frontmatter": {
        "title": "自己动手写一个 java 热加载插件",
        "date": "2021-12-21T21:43:34.000Z",
        "permalink": "/pages/86ec0a/",
        "categories": [
          "java"
        ],
        "tags": [
          "jvm"
        ],
        "sticky": 2
      },
      "regularPath": "/03.java/20.jvm/100.hot-reload.html",
      "relativePath": "03.java/20.jvm/100.hot-reload.md",
      "key": "v-bf65436a",
      "path": "/pages/86ec0a/",
      "headers": [
        {
          "level": 2,
          "title": "背景",
          "slug": "背景"
        },
        {
          "level": 2,
          "title": "问题分析",
          "slug": "问题分析"
        },
        {
          "level": 3,
          "title": "java 方法执行过程",
          "slug": "java-方法执行过程"
        },
        {
          "level": 3,
          "title": "如何在运行时获得一个 Java 类（字节码）",
          "slug": "如何在运行时获得一个-java-类-字节码"
        },
        {
          "level": 3,
          "title": "通过什么方法可以在运行时加载类",
          "slug": "通过什么方法可以在运行时加载类"
        },
        {
          "level": 2,
          "title": "确定实现方案",
          "slug": "确定实现方案"
        },
        {
          "level": 2,
          "title": "源码实现",
          "slug": "源码实现"
        },
        {
          "level": 2,
          "title": "参考",
          "slug": "参考"
        },
        {
          "level": 2,
          "title": "扩展阅读",
          "slug": "扩展阅读"
        },
        {
          "level": 3,
          "title": "tomcat 如何实现 jsp 热加载",
          "slug": "tomcat-如何实现-jsp-热加载"
        }
      ]
    },
    {
      "title": "如何正确停止一个线程",
      "frontmatter": {
        "title": "如何正确停止一个线程",
        "date": "2022-05-11T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "并发编程"
        ],
        "categories": [
          "java"
        ],
        "location": "GuangZhou",
        "permalink": "/pages/4f57d7/"
      },
      "regularPath": "/03.java/40.%E5%B9%B6%E5%8F%91%E7%BC%96%E7%A8%8B/03.thread-stop.html",
      "relativePath": "03.java/40.并发编程/03.thread-stop.md",
      "key": "v-61b67179",
      "path": "/pages/4f57d7/",
      "headers": [
        {
          "level": 2,
          "title": "禁止使用的 api",
          "slug": "禁止使用的-api"
        },
        {
          "level": 2,
          "title": "正确停止线程 - 两阶段终止模式",
          "slug": "正确停止线程-两阶段终止模式"
        }
      ]
    },
    {
      "title": "Java IO",
      "frontmatter": {
        "title": "Java IO",
        "date": "2018-12-10T23:36:05.000Z",
        "permalink": "/pages/129a86/",
        "categories": [
          "java"
        ],
        "tags": [
          "socket",
          "io"
        ]
      },
      "regularPath": "/03.java/30.%E7%BD%91%E7%BB%9C%E7%BC%96%E7%A8%8B/01.java-io.html",
      "relativePath": "03.java/30.网络编程/01.java-io.md",
      "key": "v-498e570c",
      "path": "/pages/129a86/",
      "headers": [
        {
          "level": 2,
          "title": "bio",
          "slug": "bio"
        },
        {
          "level": 2,
          "title": "nio",
          "slug": "nio"
        },
        {
          "level": 2,
          "title": "nio2(aio)",
          "slug": "nio2-aio"
        },
        {
          "level": 2,
          "title": "总结",
          "slug": "总结"
        },
        {
          "level": 3,
          "title": "同步与异步IO的区别",
          "slug": "同步与异步io的区别"
        },
        {
          "level": 3,
          "title": "阻塞与非阻塞区别",
          "slug": "阻塞与非阻塞区别"
        }
      ]
    },
    {
      "title": "java线程实践与总结",
      "frontmatter": {
        "title": "java线程实践与总结",
        "date": "2019-03-10T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "并发编程"
        ],
        "categories": [
          "java"
        ],
        "permalink": "/pages/78bf2e/"
      },
      "regularPath": "/03.java/40.%E5%B9%B6%E5%8F%91%E7%BC%96%E7%A8%8B/04.thread-awesome.html",
      "relativePath": "03.java/40.并发编程/04.thread-awesome.md",
      "key": "v-1af8d1d7",
      "path": "/pages/78bf2e/",
      "headers": [
        {
          "level": 2,
          "title": "学习教程",
          "slug": "学习教程"
        },
        {
          "level": 2,
          "title": "给创建的线程设置名称",
          "slug": "给创建的线程设置名称"
        },
        {
          "level": 2,
          "title": "如何停止线程",
          "slug": "如何停止线程"
        },
        {
          "level": 2,
          "title": "要响应线程中断异常",
          "slug": "要响应线程中断异常"
        },
        {
          "level": 2,
          "title": "ThreadLocal使用",
          "slug": "threadlocal使用"
        },
        {
          "level": 2,
          "title": "谨慎使用Executors创建线程池",
          "slug": "谨慎使用executors创建线程池"
        }
      ]
    },
    {
      "title": "线程池大小设置多少合适",
      "frontmatter": {
        "title": "线程池大小设置多少合适",
        "date": "2019-03-10T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "并发编程"
        ],
        "categories": [
          "java"
        ],
        "permalink": "/pages/335338/"
      },
      "regularPath": "/03.java/40.%E5%B9%B6%E5%8F%91%E7%BC%96%E7%A8%8B/05.thread-pool-size.html",
      "relativePath": "03.java/40.并发编程/05.thread-pool-size.md",
      "key": "v-1e490957",
      "path": "/pages/335338/",
      "headers": [
        {
          "level": 2,
          "title": "CPU 密集型",
          "slug": "cpu-密集型"
        },
        {
          "level": 2,
          "title": "I/O 密集型",
          "slug": "i-o-密集型"
        }
      ]
    },
    {
      "title": "java线程池",
      "frontmatter": {
        "title": "java线程池",
        "date": "2019-03-10T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "并发编程"
        ],
        "categories": [
          "java"
        ],
        "location": "GuangZhou",
        "permalink": "/pages/5f2440/"
      },
      "regularPath": "/03.java/40.%E5%B9%B6%E5%8F%91%E7%BC%96%E7%A8%8B/04.thread-pool.html",
      "relativePath": "03.java/40.并发编程/04.thread-pool.md",
      "key": "v-7ad6f0c3",
      "path": "/pages/5f2440/",
      "headers": [
        {
          "level": 2,
          "title": "jdk提供的常用线程池",
          "slug": "jdk提供的常用线程池"
        },
        {
          "level": 3,
          "title": "参数含义",
          "slug": "参数含义"
        },
        {
          "level": 3,
          "title": "队列类型",
          "slug": "队列类型"
        },
        {
          "level": 3,
          "title": "JDK 提供的四种拒绝策略",
          "slug": "jdk-提供的四种拒绝策略"
        },
        {
          "level": 2,
          "title": "线程池任务执行流程",
          "slug": "线程池任务执行流程"
        },
        {
          "level": 2,
          "title": "参考",
          "slug": "参考"
        }
      ]
    },
    {
      "title": "java 常用队列",
      "frontmatter": {
        "title": "java 常用队列",
        "date": "2022-05-14T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "并发编程",
          "队列"
        ],
        "categories": [
          "java"
        ],
        "location": "GuangZhou",
        "permalink": "/pages/2c5d93/"
      },
      "regularPath": "/03.java/40.%E5%B9%B6%E5%8F%91%E7%BC%96%E7%A8%8B/06.queue.html",
      "relativePath": "03.java/40.并发编程/06.queue.md",
      "key": "v-372e54ca",
      "path": "/pages/2c5d93/",
      "headers": [
        {
          "level": 2,
          "title": "Java内置队列",
          "slug": "java内置队列"
        },
        {
          "level": 3,
          "title": "添加元素",
          "slug": "添加元素"
        },
        {
          "level": 3,
          "title": "检索元素",
          "slug": "检索元素"
        }
      ]
    },
    {
      "title": "使用 Semaphore 实现一个简单限流器",
      "frontmatter": {
        "title": "使用 Semaphore 实现一个简单限流器",
        "date": "2022-05-19T00:02:38.000Z",
        "permalink": "/pages/b4b97e/",
        "categories": [
          "java"
        ],
        "tags": [
          "并发编程",
          "限流"
        ]
      },
      "regularPath": "/03.java/40.%E5%B9%B6%E5%8F%91%E7%BC%96%E7%A8%8B/07.limit.html",
      "relativePath": "03.java/40.并发编程/07.limit.md",
      "key": "v-12eaebf6",
      "path": "/pages/b4b97e/",
      "headers": [
        {
          "level": 2,
          "title": "Semaphore（信号量）的基本使用",
          "slug": "semaphore-信号量-的基本使用"
        },
        {
          "level": 2,
          "title": "限流器实现",
          "slug": "限流器实现"
        }
      ]
    },
    {
      "title": "服务端架构技能图谱",
      "frontmatter": {
        "title": "服务端架构技能图谱",
        "date": "2021-05-19T00:00:00.000Z",
        "tags": [
          "技能图谱"
        ],
        "categories": [
          "架构"
        ],
        "permalink": "/architect"
      },
      "regularPath": "/08.%E6%9E%B6%E6%9E%84/01.%E6%A6%82%E8%A7%88/01.README.html",
      "relativePath": "08.架构/01.概览/01.README.md",
      "key": "v-54bb0520",
      "path": "/architect/"
    },
    {
      "title": "软件设计原则",
      "frontmatter": {
        "title": "软件设计原则",
        "date": "2022-12-30T00:00:00.000Z",
        "permalink": "/pages/11981c/",
        "categories": [
          "架构",
          "设计模式"
        ],
        "tags": [
          "软件设计"
        ]
      },
      "regularPath": "/08.%E6%9E%B6%E6%9E%84/05.%E8%AE%BE%E8%AE%A1%E6%A8%A1%E5%BC%8F/01.README.html",
      "relativePath": "08.架构/05.设计模式/01.README.md",
      "key": "v-77d02922",
      "path": "/pages/11981c/",
      "headers": [
        {
          "level": 2,
          "title": "设计原则 SOLID",
          "slug": "设计原则-solid"
        },
        {
          "level": 3,
          "title": "单一职责（SRP）",
          "slug": "单一职责-srp"
        },
        {
          "level": 3,
          "title": "开闭原则 (OCP)",
          "slug": "开闭原则-ocp"
        },
        {
          "level": 3,
          "title": "里氏替换 (LSP)",
          "slug": "里氏替换-lsp"
        },
        {
          "level": 3,
          "title": "接口分离原则 (ISP)",
          "slug": "接口分离原则-isp"
        },
        {
          "level": 3,
          "title": "依赖倒置 (DIP)",
          "slug": "依赖倒置-dip"
        }
      ]
    },
    {
      "title": "单例模式",
      "frontmatter": {
        "title": "单例模式",
        "date": "2022-12-30T21:57:40.000Z",
        "permalink": "/pages/0c5862/",
        "categories": [
          "架构",
          "设计模式"
        ],
        "tags": [
          "单例"
        ]
      },
      "regularPath": "/08.%E6%9E%B6%E6%9E%84/05.%E8%AE%BE%E8%AE%A1%E6%A8%A1%E5%BC%8F/02.%E5%88%9B%E5%BB%BA%E5%9E%8B/10.singleton.html",
      "relativePath": "08.架构/05.设计模式/02.创建型/10.singleton.md",
      "key": "v-1e3873d3",
      "path": "/pages/0c5862/",
      "headers": [
        {
          "level": 2,
          "title": "饿汉式",
          "slug": "饿汉式"
        },
        {
          "level": 2,
          "title": "静态内部类 - 懒汉式",
          "slug": "静态内部类-懒汉式"
        },
        {
          "level": 2,
          "title": "枚举 - 懒加载",
          "slug": "枚举-懒加载"
        }
      ]
    },
    {
      "title": "装饰器模式",
      "frontmatter": {
        "title": "装饰器模式",
        "date": "2023-01-03T21:37:21.000Z",
        "permalink": "/pages/d36eab/",
        "categories": [
          "架构",
          "设计模式"
        ],
        "tags": [
          "装饰器模式"
        ]
      },
      "regularPath": "/08.%E6%9E%B6%E6%9E%84/05.%E8%AE%BE%E8%AE%A1%E6%A8%A1%E5%BC%8F/03.%E7%BB%93%E6%9E%84%E5%9E%8B/12.decorator.html",
      "relativePath": "08.架构/05.设计模式/03.结构型/12.decorator.md",
      "key": "v-194d30e6",
      "path": "/pages/d36eab/"
    },
    {
      "title": "委派模式",
      "frontmatter": {
        "title": "委派模式",
        "date": "2023-01-03T22:15:24.000Z",
        "permalink": "/pages/4c6784/",
        "categories": [
          "架构",
          "设计模式"
        ],
        "tags": [
          "委派模式"
        ]
      },
      "regularPath": "/08.%E6%9E%B6%E6%9E%84/05.%E8%AE%BE%E8%AE%A1%E6%A8%A1%E5%BC%8F/03.%E7%BB%93%E6%9E%84%E5%9E%8B/13.delegation.html",
      "relativePath": "08.架构/05.设计模式/03.结构型/13.delegation.md",
      "key": "v-e6faa118",
      "path": "/pages/4c6784/"
    },
    {
      "title": "代理模式",
      "frontmatter": {
        "title": "代理模式",
        "date": "2023-01-03T23:19:19.000Z",
        "permalink": "/pages/5a8d03/",
        "categories": [
          "架构",
          "设计模式"
        ],
        "tags": [
          "代理模式"
        ]
      },
      "regularPath": "/08.%E6%9E%B6%E6%9E%84/05.%E8%AE%BE%E8%AE%A1%E6%A8%A1%E5%BC%8F/03.%E7%BB%93%E6%9E%84%E5%9E%8B/14.proxy.html",
      "relativePath": "08.架构/05.设计模式/03.结构型/14.proxy.md",
      "key": "v-74f8eec6",
      "path": "/pages/5a8d03/",
      "headers": [
        {
          "level": 2,
          "title": "静态代理",
          "slug": "静态代理"
        },
        {
          "level": 2,
          "title": "动态代理",
          "slug": "动态代理"
        },
        {
          "level": 3,
          "title": "JDK 实现",
          "slug": "jdk-实现"
        },
        {
          "level": 3,
          "title": "cglib 实现",
          "slug": "cglib-实现"
        },
        {
          "level": 3,
          "title": "bytebuddy 实现",
          "slug": "bytebuddy-实现"
        }
      ]
    },
    {
      "title": "观察者模式",
      "frontmatter": {
        "title": "观察者模式",
        "date": "2023-01-06T11:35:03.000Z",
        "permalink": "/pages/782922/",
        "categories": [
          "架构",
          "设计模式"
        ],
        "tags": [
          "观察者模式"
        ]
      },
      "regularPath": "/08.%E6%9E%B6%E6%9E%84/05.%E8%AE%BE%E8%AE%A1%E6%A8%A1%E5%BC%8F/04.%E8%A1%8C%E4%B8%BA%E5%9E%8B/20.observer.html",
      "relativePath": "08.架构/05.设计模式/04.行为型/20.observer.md",
      "key": "v-30b54400",
      "path": "/pages/782922/",
      "headers": [
        {
          "level": 2,
          "title": "不使用第三方类库实现",
          "slug": "不使用第三方类库实现"
        },
        {
          "level": 2,
          "title": "使用guava实现",
          "slug": "使用guava实现"
        }
      ]
    },
    {
      "title": "模板方法",
      "frontmatter": {
        "title": "模板方法",
        "date": "2023-01-06T18:44:59.000Z",
        "permalink": "/pages/341eba/",
        "categories": [
          "架构",
          "设计模式"
        ],
        "tags": [
          "模板方法"
        ]
      },
      "regularPath": "/08.%E6%9E%B6%E6%9E%84/05.%E8%AE%BE%E8%AE%A1%E6%A8%A1%E5%BC%8F/04.%E8%A1%8C%E4%B8%BA%E5%9E%8B/21.template.html",
      "relativePath": "08.架构/05.设计模式/04.行为型/21.template.md",
      "key": "v-2813a68c",
      "path": "/pages/341eba/",
      "headers": [
        {
          "level": 2,
          "title": "模板模式",
          "slug": "模板模式"
        },
        {
          "level": 2,
          "title": "回调函数",
          "slug": "回调函数"
        }
      ]
    },
    {
      "title": "策略模式",
      "frontmatter": {
        "title": "策略模式",
        "date": "2023-01-09T13:50:35.000Z",
        "permalink": "/pages/1ddae1/",
        "categories": [
          "架构",
          "设计模式"
        ],
        "tags": [
          "策略模式"
        ]
      },
      "regularPath": "/08.%E6%9E%B6%E6%9E%84/05.%E8%AE%BE%E8%AE%A1%E6%A8%A1%E5%BC%8F/04.%E8%A1%8C%E4%B8%BA%E5%9E%8B/22.strategy.html",
      "relativePath": "08.架构/05.设计模式/04.行为型/22.strategy.md",
      "key": "v-a41f82ec",
      "path": "/pages/1ddae1/"
    },
    {
      "title": "ubuntu 安装 Kubernetes",
      "frontmatter": {
        "title": "ubuntu 安装 Kubernetes",
        "date": "2022-09-09T08:35:52.000Z",
        "permalink": "/pages/2ea024/",
        "categories": [
          "架构"
        ],
        "tags": [
          "云原生",
          "k8s"
        ]
      },
      "regularPath": "/08.%E6%9E%B6%E6%9E%84/100.%E4%BA%91%E5%8E%9F%E7%94%9F/01.k8s-install.html",
      "relativePath": "08.架构/100.云原生/01.k8s-install.md",
      "key": "v-ead089b2",
      "path": "/pages/2ea024/",
      "headers": [
        {
          "level": 2,
          "title": "部署架构",
          "slug": "部署架构"
        },
        {
          "level": 2,
          "title": "环境准备",
          "slug": "环境准备"
        },
        {
          "level": 2,
          "title": "安装",
          "slug": "安装"
        },
        {
          "level": 3,
          "title": "安装 kubeadm",
          "slug": "安装-kubeadm"
        },
        {
          "level": 3,
          "title": "部署 master",
          "slug": "部署-master"
        },
        {
          "level": 3,
          "title": "部署 node",
          "slug": "部署-node"
        },
        {
          "level": 2,
          "title": "测试",
          "slug": "测试"
        },
        {
          "level": 2,
          "title": "常见问题",
          "slug": "常见问题"
        },
        {
          "level": 2,
          "title": "参考",
          "slug": "参考"
        }
      ]
    },
    {
      "title": "工厂模式",
      "frontmatter": {
        "title": "工厂模式",
        "date": "2022-12-30T22:38:45.000Z",
        "permalink": "/pages/963fa5/",
        "categories": [
          "架构",
          "设计模式"
        ],
        "tags": [
          "工厂模式"
        ]
      },
      "regularPath": "/08.%E6%9E%B6%E6%9E%84/05.%E8%AE%BE%E8%AE%A1%E6%A8%A1%E5%BC%8F/02.%E5%88%9B%E5%BB%BA%E5%9E%8B/11.factory.html",
      "relativePath": "08.架构/05.设计模式/02.创建型/11.factory.md",
      "key": "v-72d3ef13",
      "path": "/pages/963fa5/",
      "headers": [
        {
          "level": 2,
          "title": "简单工厂（静态工厂）",
          "slug": "简单工厂-静态工厂"
        },
        {
          "level": 2,
          "title": "工厂方法",
          "slug": "工厂方法"
        },
        {
          "level": 2,
          "title": "抽象工厂",
          "slug": "抽象工厂"
        }
      ]
    },
    {
      "title": "安装 kubernetes-dashboard",
      "frontmatter": {
        "title": "安装 kubernetes-dashboard",
        "date": "2022-09-09T16:07:46.000Z",
        "permalink": "/pages/4d24b0/",
        "categories": [
          "架构"
        ],
        "tags": [
          "云原生",
          "k8s"
        ]
      },
      "regularPath": "/08.%E6%9E%B6%E6%9E%84/100.%E4%BA%91%E5%8E%9F%E7%94%9F/02.k8s-dashboard-install.html",
      "relativePath": "08.架构/100.云原生/02.k8s-dashboard-install.md",
      "key": "v-d4350b52",
      "path": "/pages/4d24b0/",
      "headers": [
        {
          "level": 2,
          "title": "安装",
          "slug": "安装"
        },
        {
          "level": 2,
          "title": "访问控制",
          "slug": "访问控制"
        },
        {
          "level": 2,
          "title": "用户管理",
          "slug": "用户管理"
        },
        {
          "level": 2,
          "title": "参考",
          "slug": "参考"
        }
      ]
    },
    {
      "title": "性能测试神器 wrk 使用教程",
      "frontmatter": {
        "title": "性能测试神器 wrk 使用教程",
        "description": "wrk 是一个类似 ab(apache bench)、jmeter 的压力测试工具，底层基于 epoll 和 kqueue 实现，能充分利用服务器 cpu 资源，降低测试工具对测试结果准确性的影响。使用上也非常简单，支持使用 lua 脚本自定义测试逻辑，功能非常强大。",
        "date": "2020-07-13T00:00:00.000Z",
        "tags": [
          "wrk",
          "压力测试"
        ],
        "categories": [
          "架构"
        ],
        "sticky": 3,
        "permalink": "/wrk",
        "sidebar": "auto"
      },
      "regularPath": "/08.%E6%9E%B6%E6%9E%84/20.%E6%80%A7%E8%83%BD%E4%BC%98%E5%8C%96/00.%E6%80%A7%E8%83%BD%E6%B5%8B%E8%AF%95%E5%B7%A5%E5%85%B7/01.wrk.html",
      "relativePath": "08.架构/20.性能优化/00.性能测试工具/01.wrk.md",
      "key": "v-71bdf13e",
      "path": "/wrk/",
      "headers": [
        {
          "level": 2,
          "title": "安装",
          "slug": "安装"
        },
        {
          "level": 2,
          "title": "用法",
          "slug": "用法"
        },
        {
          "level": 2,
          "title": "编写 lua 测试脚本",
          "slug": "编写-lua-测试脚本"
        },
        {
          "level": 3,
          "title": "wrk 内置函数",
          "slug": "wrk-内置函数"
        },
        {
          "level": 3,
          "title": "生命周期回调函数",
          "slug": "生命周期回调函数"
        },
        {
          "level": 3,
          "title": "官方示例",
          "slug": "官方示例"
        },
        {
          "level": 3,
          "title": "实际案例-用户信息查询接口压测",
          "slug": "实际案例-用户信息查询接口压测"
        }
      ]
    },
    {
      "title": "tomcat 性能优化",
      "frontmatter": {
        "title": "tomcat 性能优化",
        "date": "2021-01-06T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "tomcat",
          "性能优化"
        ],
        "categories": [
          "架构"
        ],
        "location": "GuangZhou",
        "permalink": "/pages/419c0e/"
      },
      "regularPath": "/08.%E6%9E%B6%E6%9E%84/20.%E6%80%A7%E8%83%BD%E4%BC%98%E5%8C%96/01.tomcat-performance.html",
      "relativePath": "08.架构/20.性能优化/01.tomcat-performance.md",
      "key": "v-5f40d645",
      "path": "/pages/419c0e/",
      "headers": [
        {
          "level": 2,
          "title": "I/O 模型选择",
          "slug": "i-o-模型选择"
        },
        {
          "level": 3,
          "title": "相关配置",
          "slug": "相关配置"
        },
        {
          "level": 3,
          "title": "apr 依赖库安装",
          "slug": "apr-依赖库安装"
        },
        {
          "level": 2,
          "title": "线程池配置",
          "slug": "线程池配置"
        },
        {
          "level": 2,
          "title": "监控",
          "slug": "监控"
        },
        {
          "level": 2,
          "title": "完整配置参考",
          "slug": "完整配置参考"
        },
        {
          "level": 2,
          "title": "官方配置说明",
          "slug": "官方配置说明"
        }
      ]
    },
    {
      "title": "zookeeper介绍",
      "frontmatter": {
        "title": "zookeeper介绍",
        "date": "2019-07-20T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "zookeeper"
        ],
        "categories": [
          "zookeeper"
        ],
        "location": "GuangZhou",
        "permalink": "/pages/c998ad/"
      },
      "regularPath": "/08.%E6%9E%B6%E6%9E%84/30.%E5%88%86%E5%B8%83%E5%BC%8F/04.zookeeper/01.README.html",
      "relativePath": "08.架构/30.分布式/04.zookeeper/01.README.md",
      "key": "v-d07de08c",
      "path": "/pages/c998ad/",
      "headers": [
        {
          "level": 2,
          "title": "zookeeper是什么",
          "slug": "zookeeper是什么"
        },
        {
          "level": 2,
          "title": "基本概念",
          "slug": "基本概念"
        },
        {
          "level": 2,
          "title": "zkCli基本使用",
          "slug": "zkcli基本使用"
        }
      ]
    },
    {
      "title": "zookeeper经典使用场景",
      "frontmatter": {
        "title": "zookeeper经典使用场景",
        "date": "2019-07-20T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "zookeeper"
        ],
        "categories": [
          "zookeeper"
        ],
        "location": "GuangZhou",
        "permalink": "/pages/d77b23/"
      },
      "regularPath": "/08.%E6%9E%B6%E6%9E%84/30.%E5%88%86%E5%B8%83%E5%BC%8F/04.zookeeper/02.case.html",
      "relativePath": "08.架构/30.分布式/04.zookeeper/02.case.md",
      "key": "v-4ddd309a",
      "path": "/pages/d77b23/",
      "headers": [
        {
          "level": 3,
          "title": "leader选举",
          "slug": "leader选举"
        },
        {
          "level": 3,
          "title": "服务注册、发现",
          "slug": "服务注册、发现"
        },
        {
          "level": 3,
          "title": "分布式锁",
          "slug": "分布式锁"
        },
        {
          "level": 3,
          "title": "消息发布、订阅",
          "slug": "消息发布、订阅"
        }
      ]
    },
    {
      "title": "OpenResty从入门到开发一个网关服务",
      "frontmatter": {
        "title": "OpenResty从入门到开发一个网关服务",
        "date": "2020-02-23T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "openresty",
          "网关",
          "微服务"
        ],
        "categories": [
          "架构"
        ],
        "location": "GuangZhou",
        "sticky": 2,
        "permalink": "/openresty/gateway"
      },
      "regularPath": "/08.%E6%9E%B6%E6%9E%84/40.%E7%BD%91%E5%85%B3/01.openresty/01.gateway.html",
      "relativePath": "08.架构/40.网关/01.openresty/01.gateway.md",
      "key": "v-15fa46f7",
      "path": "/openresty/gateway/",
      "headers": [
        {
          "level": 2,
          "title": "简介",
          "slug": "简介"
        },
        {
          "level": 2,
          "title": "入门教程",
          "slug": "入门教程"
        },
        {
          "level": 2,
          "title": "网关服务开发",
          "slug": "网关服务开发"
        },
        {
          "level": 3,
          "title": "整体架构",
          "slug": "整体架构"
        },
        {
          "level": 3,
          "title": "源码解析",
          "slug": "源码解析"
        },
        {
          "level": 3,
          "title": "运行测试",
          "slug": "运行测试"
        },
        {
          "level": 3,
          "title": "todo",
          "slug": "todo"
        }
      ]
    },
    {
      "title": "openresty 测试框架 test::nginx 安装",
      "frontmatter": {
        "title": "openresty 测试框架 test::nginx 安装",
        "date": "2020-05-02T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "openresty"
        ],
        "categories": [
          "架构"
        ],
        "location": "GuangZhou",
        "permalink": "/pages/5bffac/"
      },
      "regularPath": "/08.%E6%9E%B6%E6%9E%84/40.%E7%BD%91%E5%85%B3/01.openresty/02.test-nginx.html",
      "relativePath": "08.架构/40.网关/01.openresty/02.test-nginx.md",
      "key": "v-5e62bf4b",
      "path": "/pages/5bffac/",
      "headers": [
        {
          "level": 2,
          "title": "cpanminus 安装",
          "slug": "cpanminus-安装"
        },
        {
          "level": 2,
          "title": "通过 cpanm 安装 test::nginx模块",
          "slug": "通过-cpanm-安装-test-nginx模块"
        }
      ]
    },
    {
      "title": "不改一行源码，实现 sentinel-dashboard 所有配置支持 apollo 持久化",
      "frontmatter": {
        "title": "不改一行源码，实现 sentinel-dashboard 所有配置支持 apollo 持久化",
        "description": "不改一行源码，让 sentinel-dashboard 所有配置支持 apollo 持久化",
        "date": "2022-07-30T16:16:16.000Z",
        "permalink": "/sentinel-dashboard-apollo",
        "categories": [
          "架构"
        ],
        "tags": [
          "sentinel",
          "流量治理"
        ],
        "sticky": 4
      },
      "regularPath": "/08.%E6%9E%B6%E6%9E%84/50.%E6%B5%81%E9%87%8F%E6%B2%BB%E7%90%86/01.sentinel-dashboard-apollo.html",
      "relativePath": "08.架构/50.流量治理/01.sentinel-dashboard-apollo.md",
      "key": "v-4d30d458",
      "path": "/sentinel-dashboard-apollo/",
      "headers": [
        {
          "level": 2,
          "title": "sentinel-dashboard apollo 定制版",
          "slug": "sentinel-dashboard-apollo-定制版"
        },
        {
          "level": 2,
          "title": "sentinel-dashboard 为什么需要定制",
          "slug": "sentinel-dashboard-为什么需要定制"
        },
        {
          "level": 2,
          "title": "方案选型",
          "slug": "方案选型"
        },
        {
          "level": 2,
          "title": "源码分析",
          "slug": "源码分析"
        },
        {
          "level": 2,
          "title": "改造实现",
          "slug": "改造实现"
        },
        {
          "level": 2,
          "title": "改造后的效果",
          "slug": "改造后的效果"
        },
        {
          "level": 2,
          "title": "升级&版本维护",
          "slug": "升级-版本维护"
        },
        {
          "level": 2,
          "title": "相关文档",
          "slug": "相关文档"
        }
      ]
    },
    {
      "title": "sentinel-dashboard-apollo 使用",
      "frontmatter": {
        "title": "sentinel-dashboard-apollo 使用",
        "date": "2022-08-01T01:26:33.000Z",
        "permalink": "/sentinel-dashboard-apollo-wiki",
        "categories": [
          "架构"
        ],
        "tags": [
          "sentinel",
          "流量治理"
        ]
      },
      "regularPath": "/08.%E6%9E%B6%E6%9E%84/50.%E6%B5%81%E9%87%8F%E6%B2%BB%E7%90%86/02.sentinel-dashboard-apollo-wiki.html",
      "relativePath": "08.架构/50.流量治理/02.sentinel-dashboard-apollo-wiki.md",
      "key": "v-7d13fff4",
      "path": "/sentinel-dashboard-apollo-wiki/",
      "headers": [
        {
          "level": 2,
          "title": "说明",
          "slug": "说明"
        },
        {
          "level": 2,
          "title": "获取 sentinel-dashboard-apollo",
          "slug": "获取-sentinel-dashboard-apollo"
        },
        {
          "level": 2,
          "title": "apollo 开放平台配置",
          "slug": "apollo-开放平台配置"
        },
        {
          "level": 2,
          "title": "启动 dashboard",
          "slug": "启动-dashboard"
        },
        {
          "level": 3,
          "title": "启动参数",
          "slug": "启动参数"
        },
        {
          "level": 3,
          "title": "docker 方式启动",
          "slug": "docker-方式启动"
        },
        {
          "level": 2,
          "title": "dataId 命名规则",
          "slug": "dataid-命名规则"
        },
        {
          "level": 2,
          "title": "客户端配置",
          "slug": "客户端配置"
        },
        {
          "level": 3,
          "title": "动态规则扩展 - 普通应用接入参考",
          "slug": "动态规则扩展-普通应用接入参考"
        },
        {
          "level": 3,
          "title": "Spring Cloud Alibaba Sentinel 参考",
          "slug": "spring-cloud-alibaba-sentinel-参考"
        },
        {
          "level": 3,
          "title": "spring-boot(cloud) 整合 demo",
          "slug": "spring-boot-cloud-整合-demo"
        },
        {
          "level": 2,
          "title": "交流群",
          "slug": "交流群"
        }
      ]
    },
    {
      "title": "MySQL 异构数据同步方案 - canal 高可用部署",
      "frontmatter": {
        "title": "MySQL 异构数据同步方案 - canal 高可用部署",
        "date": "2022-12-22T00:28:41.000Z",
        "permalink": "/pages/62b861/",
        "categories": [
          "架构",
          "数据治理"
        ],
        "tags": [
          "mysql",
          "canal"
        ],
        "sticky": 5
      },
      "regularPath": "/08.%E6%9E%B6%E6%9E%84/60.%E6%95%B0%E6%8D%AE%E6%B2%BB%E7%90%86/05.mysql%E6%95%B0%E6%8D%AE%E5%90%8C%E6%AD%A5%E6%96%B9%E6%A1%88-canal%E9%AB%98%E5%8F%AF%E7%94%A8%E9%83%A8%E7%BD%B2.html",
      "relativePath": "08.架构/60.数据治理/05.mysql数据同步方案-canal高可用部署.md",
      "key": "v-625a59c6",
      "path": "/pages/62b861/",
      "headers": [
        {
          "level": 2,
          "title": "canal 是什么",
          "slug": "canal-是什么"
        },
        {
          "level": 3,
          "title": "架构",
          "slug": "架构"
        },
        {
          "level": 3,
          "title": "组件",
          "slug": "组件"
        },
        {
          "level": 3,
          "title": "逻辑概念",
          "slug": "逻辑概念"
        },
        {
          "level": 2,
          "title": "部署",
          "slug": "部署"
        },
        {
          "level": 3,
          "title": "环境准备",
          "slug": "环境准备"
        },
        {
          "level": 3,
          "title": "部署 canal-admin",
          "slug": "部署-canal-admin"
        },
        {
          "level": 3,
          "title": "部署 canal-deployer",
          "slug": "部署-canal-deployer"
        },
        {
          "level": 3,
          "title": "配置 Instance",
          "slug": "配置-instance"
        },
        {
          "level": 3,
          "title": "部署 canal-adapter",
          "slug": "部署-canal-adapter"
        },
        {
          "level": 3,
          "title": "测试",
          "slug": "测试"
        },
        {
          "level": 2,
          "title": "监控",
          "slug": "监控"
        },
        {
          "level": 2,
          "title": "参考",
          "slug": "参考"
        }
      ]
    },
    {
      "title": "Java开发手册-嵩山版",
      "frontmatter": {
        "title": "Java开发手册-嵩山版",
        "date": "2020-08-20T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "java",
          "book"
        ],
        "location": "GuangZhou",
        "permalink": "/book/java/alibaba-java-manual",
        "categories": [
          "book",
          "java"
        ]
      },
      "regularPath": "/09.book/01.java/01.alibaba-java-manual.html",
      "relativePath": "09.book/01.java/01.alibaba-java-manual.md",
      "key": "v-72ef2f8f",
      "path": "/book/java/alibaba-java-manual/"
    },
    {
      "title": "effective-java 第三版",
      "frontmatter": {
        "title": "effective-java 第三版",
        "date": "2020-08-20T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "java",
          "book"
        ],
        "location": "GuangZhou",
        "permalink": "/book/java/effective-java-3",
        "categories": [
          "book",
          "java"
        ]
      },
      "regularPath": "/09.book/01.java/02.effective-java-3.html",
      "relativePath": "09.book/01.java/02.effective-java-3.md",
      "key": "v-716d7f2b",
      "path": "/book/java/effective-java-3/"
    },
    {
      "title": "重构-改善既有代码的设计",
      "frontmatter": {
        "title": "重构-改善既有代码的设计",
        "date": "2020-08-20T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "java",
          "book"
        ],
        "location": "GuangZhou",
        "permalink": "/book/java/refactor",
        "categories": [
          "book",
          "java"
        ]
      },
      "regularPath": "/09.book/01.java/03.refactor.html",
      "relativePath": "09.book/01.java/03.refactor.md",
      "key": "v-6389cc8b",
      "path": "/book/java/refactor/"
    },
    {
      "title": "Google Guava官方教程",
      "frontmatter": {
        "title": "Google Guava官方教程",
        "date": "2020-08-20T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "java",
          "book"
        ],
        "location": "GuangZhou",
        "permalink": "/book/java/google-guava",
        "categories": [
          "book",
          "java"
        ]
      },
      "regularPath": "/09.book/01.java/04.google-guava.html",
      "relativePath": "09.book/01.java/04.google-guava.md",
      "key": "v-19aaeeeb",
      "path": "/book/java/google-guava/"
    },
    {
      "title": "深入理解Java虚拟机-第3版",
      "frontmatter": {
        "title": "深入理解Java虚拟机-第3版",
        "date": "2020-12-26T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "java",
          "book"
        ],
        "location": "GuangZhou",
        "permalink": "/book/java/inside-in-jvm",
        "categories": [
          "book",
          "java"
        ]
      },
      "regularPath": "/09.book/01.java/05.inside%20in-jvm.html",
      "relativePath": "09.book/01.java/05.inside in-jvm.md",
      "key": "v-9a8449ac",
      "path": "/book/java/inside-in-jvm/"
    },
    {
      "title": "nginx 文档",
      "frontmatter": {
        "title": "nginx 文档",
        "date": "2020-08-20T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "nginx",
          "book"
        ],
        "location": "GuangZhou",
        "permalink": "/book/nginx",
        "categories": [
          "book",
          "nginx"
        ]
      },
      "regularPath": "/09.book/02.nginx/01.nginx.html",
      "relativePath": "09.book/02.nginx/01.nginx.md",
      "key": "v-41dd9e6b",
      "path": "/book/nginx/"
    },
    {
      "title": "OpenResty 最佳实践",
      "frontmatter": {
        "title": "OpenResty 最佳实践",
        "date": "2020-08-20T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "openresty",
          "book"
        ],
        "location": "GuangZhou",
        "permalink": "/book/nginx/openresty",
        "categories": [
          "book",
          "nginx"
        ]
      },
      "regularPath": "/09.book/02.nginx/02.openresty.html",
      "relativePath": "09.book/02.nginx/02.openresty.md",
      "key": "v-4642faab",
      "path": "/book/nginx/openresty/"
    },
    {
      "title": "agentzh 的 Nginx 教程",
      "frontmatter": {
        "title": "agentzh 的 Nginx 教程",
        "date": "2020-08-20T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "nginx",
          "book"
        ],
        "location": "GuangZhou",
        "permalink": "/book/nginx/agentzh-nginx",
        "categories": [
          "book",
          "nginx"
        ]
      },
      "regularPath": "/09.book/02.nginx/03.agentzh-nginx.html",
      "relativePath": "09.book/02.nginx/03.agentzh-nginx.md",
      "key": "v-b4f3a32a",
      "path": "/book/nginx/agentzh-nginx/"
    },
    {
      "title": "web前端黑客技术揭秘",
      "frontmatter": {
        "title": "web前端黑客技术揭秘",
        "date": "2020-08-20T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "security",
          "book"
        ],
        "location": "GuangZhou",
        "permalink": "/book/security/web-hacking-tech-revealed",
        "categories": [
          "book",
          "security"
        ]
      },
      "regularPath": "/09.book/03.security/01.web-hacking-tech-revealed.html",
      "relativePath": "09.book/03.security/01.web-hacking-tech-revealed.md",
      "key": "v-2c3605cb",
      "path": "/book/security/web-hacking-tech-revealed/"
    },
    {
      "title": "Linux 命令大全完整版",
      "frontmatter": {
        "title": "Linux 命令大全完整版",
        "date": "2020-08-20T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "linux",
          "cmd",
          "book"
        ],
        "location": "GuangZhou",
        "permalink": "/book/sre/linux-cmd",
        "categories": [
          "book",
          "sre"
        ]
      },
      "regularPath": "/09.book/04.sre/01.linux-cmd.html",
      "relativePath": "09.book/04.sre/01.linux-cmd.md",
      "key": "v-8caa486a",
      "path": "/book/sre/linux-cmd/"
    },
    {
      "title": "白帽子讲Web安全",
      "frontmatter": {
        "title": "白帽子讲Web安全",
        "date": "2020-08-20T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "security",
          "book"
        ],
        "location": "GuangZhou",
        "permalink": "/book/security/white-hat-web-security",
        "categories": [
          "book",
          "security"
        ]
      },
      "regularPath": "/09.book/03.security/02.white-hat-web-security.html",
      "relativePath": "09.book/03.security/02.white-hat-web-security.md",
      "key": "v-1ca90dcb",
      "path": "/book/security/white-hat-web-security/"
    },
    {
      "title": "shell 编程范例",
      "frontmatter": {
        "title": "shell 编程范例",
        "date": "2020-08-20T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "shell",
          "book"
        ],
        "location": "GuangZhou",
        "permalink": "/book/sre/shellbook",
        "categories": [
          "book",
          "sre"
        ]
      },
      "regularPath": "/09.book/04.sre/02.shellbook.html",
      "relativePath": "09.book/04.sre/02.shellbook.md",
      "key": "v-9ed1f22a",
      "path": "/book/sre/shellbook/"
    },
    {
      "title": "鸟哥的Linux私房菜-基础篇-第四版",
      "frontmatter": {
        "title": "鸟哥的Linux私房菜-基础篇-第四版",
        "date": "2020-08-20T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "linux",
          "book"
        ],
        "location": "GuangZhou",
        "permalink": "/book/sre/vbird-linux-basic-4",
        "categories": [
          "book",
          "sre"
        ]
      },
      "regularPath": "/09.book/04.sre/03.vbird-linux-basic-4.html",
      "relativePath": "09.book/04.sre/03.vbird-linux-basic-4.md",
      "key": "v-0ad53ceb",
      "path": "/book/sre/vbird-linux-basic-4/"
    },
    {
      "title": "MySQL-InnoDB 存储引擎概述",
      "frontmatter": {
        "title": "MySQL-InnoDB 存储引擎概述",
        "date": "2020-08-07T00:00:00.000Z",
        "permalink": "/pages/8f6be4/",
        "categories": [
          "mysql"
        ],
        "tags": [
          "mysql",
          "InnoDB"
        ]
      },
      "regularPath": "/10.%E6%95%B0%E6%8D%AE%E5%BA%93/01.mysql/01.InnoDB.html",
      "relativePath": "10.数据库/01.mysql/01.InnoDB.md",
      "key": "v-29cf8700",
      "path": "/pages/8f6be4/",
      "headers": [
        {
          "level": 2,
          "title": "整体架构",
          "slug": "整体架构"
        },
        {
          "level": 2,
          "title": "内存结构",
          "slug": "内存结构"
        },
        {
          "level": 3,
          "title": "缓冲池（Buffer Pool）",
          "slug": "缓冲池-buffer-pool"
        },
        {
          "level": 3,
          "title": "写（修改）缓冲（Change Buffer）",
          "slug": "写-修改-缓冲-change-buffer"
        },
        {
          "level": 3,
          "title": "自适应哈希索引（Adaptive Hash Index）",
          "slug": "自适应哈希索引-adaptive-hash-index"
        },
        {
          "level": 3,
          "title": "日志缓冲（Log Buffer）",
          "slug": "日志缓冲-log-buffer"
        },
        {
          "level": 2,
          "title": "磁盘结构",
          "slug": "磁盘结构"
        }
      ]
    },
    {
      "title": "MySql 索引",
      "frontmatter": {
        "title": "MySql 索引",
        "description": null,
        "date": "2020-08-08T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "mysql"
        ],
        "categories": [
          "mysql"
        ],
        "location": "GuangZhou",
        "permalink": "/pages/fc05b5/"
      },
      "regularPath": "/10.%E6%95%B0%E6%8D%AE%E5%BA%93/01.mysql/02.mysql-index.html",
      "relativePath": "10.数据库/01.mysql/02.mysql-index.md",
      "key": "v-e9915c6c",
      "path": "/pages/fc05b5/",
      "headers": [
        {
          "level": 2,
          "title": "带索引字段查询条件的 sql 查询过程",
          "slug": "带索引字段查询条件的-sql-查询过程"
        },
        {
          "level": 2,
          "title": "覆盖索引",
          "slug": "覆盖索引"
        },
        {
          "level": 2,
          "title": "最左前缀原则",
          "slug": "最左前缀原则"
        },
        {
          "level": 2,
          "title": "索引下推",
          "slug": "索引下推"
        },
        {
          "level": 2,
          "title": "索引分类",
          "slug": "索引分类"
        },
        {
          "level": 3,
          "title": "聚簇索引和非聚簇索引",
          "slug": "聚簇索引和非聚簇索引"
        },
        {
          "level": 3,
          "title": "普通索引和唯一索引对比",
          "slug": "普通索引和唯一索引对比"
        },
        {
          "level": 2,
          "title": "实践",
          "slug": "实践"
        },
        {
          "level": 3,
          "title": "索引创建原则",
          "slug": "索引创建原则"
        },
        {
          "level": 3,
          "title": "给字符串加索引的一些实践",
          "slug": "给字符串加索引的一些实践"
        },
        {
          "level": 3,
          "title": "已经建了索引，sql执行却没有走索引",
          "slug": "已经建了索引-sql执行却没有走索引"
        },
        {
          "level": 3,
          "title": "创建索引",
          "slug": "创建索引"
        }
      ]
    },
    {
      "title": "MySql 事务",
      "frontmatter": {
        "title": "MySql 事务",
        "description": null,
        "date": "2020-07-10T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "mysql"
        ],
        "categories": [
          "mysql"
        ],
        "location": "GuangZhou",
        "permalink": "/pages/e4f078/"
      },
      "regularPath": "/10.%E6%95%B0%E6%8D%AE%E5%BA%93/01.mysql/03.transaction.html",
      "relativePath": "10.数据库/01.mysql/03.transaction.md",
      "key": "v-f2ef1a4c",
      "path": "/pages/e4f078/",
      "headers": [
        {
          "level": 2,
          "title": "事务特性: ACID",
          "slug": "事务特性-acid"
        },
        {
          "level": 2,
          "title": "事务隔离级别",
          "slug": "事务隔离级别"
        },
        {
          "level": 2,
          "title": "事务隔离的实现",
          "slug": "事务隔离的实现"
        },
        {
          "level": 2,
          "title": "查询数据库隔离级别",
          "slug": "查询数据库隔离级别"
        },
        {
          "level": 2,
          "title": "修改事务级别",
          "slug": "修改事务级别"
        },
        {
          "level": 2,
          "title": "如何选择事务隔离级别",
          "slug": "如何选择事务隔离级别"
        }
      ]
    },
    {
      "title": "MySql 日志系统（WAL）",
      "frontmatter": {
        "title": "MySql 日志系统（WAL）",
        "description": "MySQL日志系统（redolog和binlog）",
        "date": "2019-11-10T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "mysql"
        ],
        "categories": [
          "mysql"
        ],
        "location": "GuangZhou",
        "permalink": "/pages/0e45e4/"
      },
      "regularPath": "/10.%E6%95%B0%E6%8D%AE%E5%BA%93/01.mysql/04.log.html",
      "relativePath": "10.数据库/01.mysql/04.log.md",
      "key": "v-b8b6d6e8",
      "path": "/pages/0e45e4/",
      "headers": [
        {
          "level": 2,
          "title": "redo log - 重做日志",
          "slug": "redo-log-重做日志"
        },
        {
          "level": 2,
          "title": "binlog - 归档日志",
          "slug": "binlog-归档日志"
        },
        {
          "level": 2,
          "title": "两阶段提交",
          "slug": "两阶段提交"
        }
      ]
    },
    {
      "title": "MySql order by 的执行过程与优化",
      "frontmatter": {
        "title": "MySql order by 的执行过程与优化",
        "description": null,
        "date": "2020-08-10T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "mysql"
        ],
        "categories": [
          "mysql"
        ],
        "location": "GuangZhou",
        "permalink": "/pages/9239fb/"
      },
      "regularPath": "/10.%E6%95%B0%E6%8D%AE%E5%BA%93/01.mysql/05.order-by.html",
      "relativePath": "10.数据库/01.mysql/05.order-by.md",
      "key": "v-416ada00",
      "path": "/pages/9239fb/",
      "headers": [
        {
          "level": 2,
          "title": "执行过程",
          "slug": "执行过程"
        },
        {
          "level": 2,
          "title": "优化方案",
          "slug": "优化方案"
        }
      ]
    },
    {
      "title": "MySQL 性能分析与常见性能问题总结",
      "frontmatter": {
        "title": "MySQL 性能分析与常见性能问题总结",
        "description": "MySQL 性能常见问题和分析优化方法总结",
        "date": "2020-08-27T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "mysql",
          "性能分析"
        ],
        "categories": [
          "mysql"
        ],
        "permalink": "/pages/3ce3c6/"
      },
      "regularPath": "/10.%E6%95%B0%E6%8D%AE%E5%BA%93/01.mysql/06.performance.html",
      "relativePath": "10.数据库/01.mysql/06.performance.md",
      "key": "v-606b70a0",
      "path": "/pages/3ce3c6/",
      "headers": [
        {
          "level": 2,
          "title": "性能分析工具",
          "slug": "性能分析工具"
        },
        {
          "level": 3,
          "title": "slow log 慢查询日志",
          "slug": "slow-log-慢查询日志"
        },
        {
          "level": 3,
          "title": "explain 查看执行计划",
          "slug": "explain-查看执行计划"
        },
        {
          "level": 3,
          "title": "show profile 分析每一步的耗时",
          "slug": "show-profile-分析每一步的耗时"
        },
        {
          "level": 3,
          "title": "系统性能监控表performance_schema",
          "slug": "系统性能监控表performance-schema"
        },
        {
          "level": 2,
          "title": "导致 sql 慢的常见原因和解决方案",
          "slug": "导致-sql-慢的常见原因和解决方案"
        },
        {
          "level": 3,
          "title": "MySQL本身压力过大，cpu 使用率和 ioutil 过高",
          "slug": "mysql本身压力过大-cpu-使用率和-ioutil-过高"
        },
        {
          "level": 3,
          "title": "刷脏页，导致同一个 sql 偶尔变慢",
          "slug": "刷脏页-导致同一个-sql-偶尔变慢"
        },
        {
          "level": 3,
          "title": "mdl 锁导致一个简单的查询",
          "slug": "mdl-锁导致一个简单的查询"
        },
        {
          "level": 3,
          "title": "索引失效",
          "slug": "索引失效"
        }
      ]
    },
    {
      "title": "mysql推荐使用规范",
      "frontmatter": {
        "title": "mysql推荐使用规范",
        "date": "2019-11-10T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "mysql"
        ],
        "categories": [
          "mysql"
        ],
        "location": "GuangZhou",
        "permalink": "/pages/58ee1f/"
      },
      "regularPath": "/10.%E6%95%B0%E6%8D%AE%E5%BA%93/01.mysql/08.specification.html",
      "relativePath": "10.数据库/01.mysql/08.specification.md",
      "key": "v-81d08974",
      "path": "/pages/58ee1f/",
      "headers": [
        {
          "level": 3,
          "title": "一:基础规范",
          "slug": "一-基础规范"
        },
        {
          "level": 3,
          "title": "二:命名规范",
          "slug": "二-命名规范"
        },
        {
          "level": 3,
          "title": "三:字段设计规范",
          "slug": "三-字段设计规范"
        },
        {
          "level": 3,
          "title": "四:索引设计规范",
          "slug": "四-索引设计规范"
        },
        {
          "level": 3,
          "title": "五:SQL使用规范",
          "slug": "五-sql使用规范"
        }
      ]
    },
    {
      "title": "MySQL 常用配置整理",
      "frontmatter": {
        "title": "MySQL 常用配置整理",
        "date": "2022-11-29T22:32:44.000Z",
        "permalink": "/pages/744ea9/",
        "tags": [
          "mysql",
          "配置"
        ],
        "categories": [
          "mysql"
        ]
      },
      "regularPath": "/10.%E6%95%B0%E6%8D%AE%E5%BA%93/01.mysql/09.options.html",
      "relativePath": "10.数据库/01.mysql/09.options.md",
      "key": "v-24b4a7ce",
      "path": "/pages/744ea9/",
      "headers": [
        {
          "level": 2,
          "title": "性能",
          "slug": "性能"
        },
        {
          "level": 2,
          "title": "日志",
          "slug": "日志"
        }
      ]
    },
    {
      "title": "mysql常用命令整理",
      "frontmatter": {
        "title": "mysql常用命令整理",
        "date": "2019-11-10T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "mysql",
          "手册"
        ],
        "categories": [
          "mysql"
        ],
        "location": "GuangZhou",
        "permalink": "/pages/1af172/"
      },
      "regularPath": "/10.%E6%95%B0%E6%8D%AE%E5%BA%93/01.mysql/10.cmd.html",
      "relativePath": "10.数据库/01.mysql/10.cmd.md",
      "key": "v-9e58f22c",
      "path": "/pages/1af172/",
      "headers": [
        {
          "level": 2,
          "title": "连接mysql server",
          "slug": "连接mysql-server"
        },
        {
          "level": 2,
          "title": "DCL",
          "slug": "dcl"
        },
        {
          "level": 2,
          "title": "DDL",
          "slug": "ddl"
        },
        {
          "level": 2,
          "title": "导出、导入",
          "slug": "导出、导入"
        },
        {
          "level": 2,
          "title": "查看表锁情况",
          "slug": "查看表锁情况"
        },
        {
          "level": 2,
          "title": "INFORMATION_SCHEMA",
          "slug": "information-schema"
        },
        {
          "level": 3,
          "title": "查看所有非系统表（超过200MB）占用磁盘空间情况",
          "slug": "查看所有非系统表-超过200mb-占用磁盘空间情况"
        },
        {
          "level": 3,
          "title": "查找持续时间超过 60s 的事务",
          "slug": "查找持续时间超过-60s-的事务"
        },
        {
          "level": 2,
          "title": "查看mysql进程会话情况",
          "slug": "查看mysql进程会话情况"
        },
        {
          "level": 2,
          "title": "查看系统参数",
          "slug": "查看系统参数"
        },
        {
          "level": 2,
          "title": "binlog 相关",
          "slug": "binlog-相关"
        },
        {
          "level": 2,
          "title": "在 shell 脚本中执行 mysql 命令",
          "slug": "在-shell-脚本中执行-mysql-命令"
        }
      ]
    },
    {
      "title": "mycli-强大的MySQL命令行客户端",
      "frontmatter": {
        "title": "mycli-强大的MySQL命令行客户端",
        "date": "2019-11-10T00:00:00.000Z",
        "author": "FengJianxin",
        "tags": [
          "mysql"
        ],
        "categories": [
          "mysql"
        ],
        "location": "GuangZhou",
        "permalink": "/pages/9ecfb4/"
      },
      "regularPath": "/10.%E6%95%B0%E6%8D%AE%E5%BA%93/01.mysql/20.mycli.html",
      "relativePath": "10.数据库/01.mysql/20.mycli.md",
      "key": "v-3473d938",
      "path": "/pages/9ecfb4/",
      "headers": [
        {
          "level": 3,
          "title": "安装",
          "slug": "安装"
        },
        {
          "level": 3,
          "title": "使用方法",
          "slug": "使用方法"
        },
        {
          "level": 3,
          "title": "使用SSH tunnel连接远程MySQL",
          "slug": "使用ssh-tunnel连接远程mysql"
        },
        {
          "level": 3,
          "title": "更多功能",
          "slug": "更多功能"
        }
      ]
    },
    {
      "title": "redis key-value 存储结构及扩容",
      "frontmatter": {
        "title": "redis key-value 存储结构及扩容",
        "date": "2022-12-04T16:07:43.000Z",
        "permalink": "/pages/b30316/",
        "categories": [
          "数据库&缓存",
          "redis"
        ],
        "tags": [
          "redis"
        ]
      },
      "regularPath": "/10.%E6%95%B0%E6%8D%AE%E5%BA%93/02.redis/00.redis-kv-rehash.html",
      "relativePath": "10.数据库/02.redis/00.redis-kv-rehash.md",
      "key": "v-cedceca4",
      "path": "/pages/b30316/",
      "headers": [
        {
          "level": 2,
          "title": "全局key-value存储结构",
          "slug": "全局key-value存储结构"
        },
        {
          "level": 2,
          "title": "redis 如何解决哈希冲突问题",
          "slug": "redis-如何解决哈希冲突问题"
        },
        {
          "level": 2,
          "title": "参考",
          "slug": "参考"
        }
      ]
    },
    {
      "title": "redis 数据类型对应的数据结构",
      "frontmatter": {
        "title": "redis 数据类型对应的数据结构",
        "date": "2022-05-22T15:14:22.000Z",
        "permalink": "/pages/7d45f8/",
        "categories": [
          "数据库&缓存",
          "redis"
        ],
        "tags": [
          "redis"
        ]
      },
      "regularPath": "/10.%E6%95%B0%E6%8D%AE%E5%BA%93/02.redis/01.redis-structure.html",
      "relativePath": "10.数据库/02.redis/01.redis-structure.md",
      "key": "v-77cadee8",
      "path": "/pages/7d45f8/",
      "headers": [
        {
          "level": 2,
          "title": "压缩列表 (ziplist) 介绍",
          "slug": "压缩列表-ziplist-介绍"
        },
        {
          "level": 2,
          "title": "字符串 - string",
          "slug": "字符串-string"
        },
        {
          "level": 2,
          "title": "列表 - list",
          "slug": "列表-list"
        },
        {
          "level": 2,
          "title": "字典 - hash",
          "slug": "字典-hash"
        },
        {
          "level": 2,
          "title": "集合 - set",
          "slug": "集合-set"
        },
        {
          "level": 2,
          "title": "有序集合 - sortedset",
          "slug": "有序集合-sortedset"
        },
        {
          "level": 2,
          "title": "汇总",
          "slug": "汇总"
        },
        {
          "level": 2,
          "title": "参考",
          "slug": "参考"
        }
      ]
    },
    {
      "title": "redis 数据持久化",
      "frontmatter": {
        "title": "redis 数据持久化",
        "date": "2022-12-04T23:12:22.000Z",
        "permalink": "/pages/81a37c/",
        "categories": [
          "数据库&缓存",
          "redis"
        ],
        "tags": [
          "redis"
        ]
      },
      "regularPath": "/10.%E6%95%B0%E6%8D%AE%E5%BA%93/02.redis/02.redis-persistence.html",
      "relativePath": "10.数据库/02.redis/02.redis-persistence.md",
      "key": "v-26decd72",
      "path": "/pages/81a37c/",
      "headers": [
        {
          "level": 2,
          "title": "AOF（append only file）",
          "slug": "aof-append-only-file"
        },
        {
          "level": 3,
          "title": "AOF 重写（aofrewrite）",
          "slug": "aof-重写-aofrewrite"
        },
        {
          "level": 2,
          "title": "RDB",
          "slug": "rdb"
        },
        {
          "level": 2,
          "title": "混合模式",
          "slug": "混合模式"
        },
        {
          "level": 2,
          "title": "常见问题",
          "slug": "常见问题"
        },
        {
          "level": 3,
          "title": "案例分析",
          "slug": "案例分析"
        },
        {
          "level": 2,
          "title": "参考",
          "slug": "参考"
        }
      ]
    },
    {
      "title": "常用 shell 脚本样例",
      "frontmatter": {
        "title": "常用 shell 脚本样例",
        "date": "2020-12-31T00:00:00.000Z",
        "author": "FengJianxin",
        "sidebar": "auto",
        "tags": [
          "shell",
          "linux"
        ],
        "categories": [
          "运维"
        ],
        "location": "GuangZhou",
        "sticky": 5,
        "permalink": "/pages/95c88a/"
      },
      "regularPath": "/100.%E5%85%B6%E4%BB%96/01.linux/01.bash.html",
      "relativePath": "100.其他/01.linux/01.bash.md",
      "key": "v-63c01e10",
      "path": "/pages/95c88a/",
      "headers": [
        {
          "level": 2,
          "title": "参数",
          "slug": "参数"
        },
        {
          "level": 2,
          "title": "shell 脚本样例",
          "slug": "shell-脚本样例"
        },
        {
          "level": 2,
          "title": "写出健壮性更好的脚本",
          "slug": "写出健壮性更好的脚本"
        }
      ]
    },
    {
      "title": "idea",
      "frontmatter": {
        "title": "idea",
        "date": "2020-06-16T23:36:05.000Z",
        "permalink": "/pages/019efa/",
        "categories": [
          "tools"
        ],
        "tags": [
          "ide"
        ]
      },
      "regularPath": "/100.%E5%85%B6%E4%BB%96/02.tools/01.idea.html",
      "relativePath": "100.其他/02.tools/01.idea.md",
      "key": "v-1bbe32f0",
      "path": "/pages/019efa/",
      "headers": [
        {
          "level": 2,
          "title": "使用教程",
          "slug": "使用教程"
        },
        {
          "level": 2,
          "title": "解决编辑大文件占用大量CPU问题",
          "slug": "解决编辑大文件占用大量cpu问题"
        },
        {
          "level": 3,
          "title": "Java 8",
          "slug": "java-8"
        },
        {
          "level": 3,
          "title": "All platforms: download and install JetBrains Runtime via JB SDK Bintray Downloader plug-in",
          "slug": "all-platforms-download-and-install-jetbrains-runtime-via-jb-sdk-bintray-downloader-plug-in"
        },
        {
          "level": 3,
          "title": "All platforms: switch between installed runtimes",
          "slug": "all-platforms-switch-between-installed-runtimes"
        }
      ]
    },
    {
      "title": "常用算法 - lru cache",
      "frontmatter": {
        "title": "常用算法 - lru cache",
        "author": "FengJianxin",
        "date": "2022-04-14T23:33:17.000Z",
        "tags": [
          "lru cache"
        ],
        "categories": [
          "数据结构与算法"
        ],
        "location": "GuangZhou",
        "permalink": "/alg/lru-cache"
      },
      "regularPath": "/20.alg/02.lru-cache.html",
      "relativePath": "20.alg/02.lru-cache.md",
      "key": "v-018ef36b",
      "path": "/alg/lru-cache/",
      "headers": [
        {
          "level": 2,
          "title": "java 实现",
          "slug": "java-实现"
        }
      ]
    },
    {
      "title": "关于",
      "frontmatter": {
        "title": "关于",
        "date": "2019-02-28T00:00:00.000Z",
        "author": "FengJianxin",
        "sidebar": false,
        "permalink": "/about",
        "categories": [
          "关于"
        ],
        "tags": [
          null
        ]
      },
      "regularPath": "/50.%E5%85%B3%E4%BA%8E/01.about.html",
      "relativePath": "50.关于/01.about.md",
      "key": "v-b3a5899a",
      "path": "/about/",
      "headers": [
        {
          "level": 3,
          "title": "联系",
          "slug": "联系"
        },
        {
          "level": 3,
          "title": "个人微信",
          "slug": "个人微信"
        }
      ]
    },
    {
      "title": "链接",
      "frontmatter": {
        "title": "链接",
        "date": "2019-02-28T00:00:00.000Z",
        "sidebar": false,
        "permalink": "/links",
        "categories": [
          "链接"
        ],
        "tags": [
          null
        ]
      },
      "regularPath": "/51.%E9%93%BE%E6%8E%A5/01.links.html",
      "relativePath": "51.链接/01.links.md",
      "key": "v-74958907",
      "path": "/links/"
    },
    {
      "title": "chrome离线安装包下载",
      "frontmatter": {
        "title": "chrome离线安装包下载",
        "date": "-",
        "tags": [
          "chrome"
        ],
        "permalink": "/pages/0bdae1/",
        "categories": [
          "参考文档"
        ],
        "sidebar": "auto"
      },
      "regularPath": "/_posts/%E5%8F%82%E8%80%83%E6%96%87%E6%A1%A3/chrome-download.html",
      "relativePath": "_posts/参考文档/chrome-download.md",
      "key": "v-2701192e",
      "path": "/pages/0bdae1/"
    },
    {
      "title": "ffmpeg 合并 m3u8 视频文件",
      "frontmatter": {
        "title": "ffmpeg 合并 m3u8 视频文件",
        "date": "-",
        "tags": [
          "ffmpeg",
          "m3u8"
        ],
        "permalink": "/pages/e1e29a/",
        "categories": [
          "参考文档"
        ],
        "sidebar": "auto",
        "article": false
      },
      "regularPath": "/_posts/%E5%8F%82%E8%80%83%E6%96%87%E6%A1%A3/ffmpeg-merge-video.html",
      "relativePath": "_posts/参考文档/ffmpeg-merge-video.md",
      "key": "v-67169a4a",
      "path": "/pages/e1e29a/",
      "headers": [
        {
          "level": 2,
          "title": "ffmpeg合并视频文件，对于 MPEG 格式的视频，可以直接连接：",
          "slug": "ffmpeg合并视频文件-对于-mpeg-格式的视频-可以直接连接"
        },
        {
          "level": 2,
          "title": "ffmpeg 下载 m3u8 直播流",
          "slug": "ffmpeg-下载-m3u8-直播流"
        }
      ]
    },
    {
      "title": "git-flow工作流程",
      "frontmatter": {
        "title": "git-flow工作流程",
        "date": "-",
        "tags": [
          "git"
        ],
        "permalink": "/pages/6ff370/",
        "categories": [
          "参考文档"
        ],
        "sidebar": "auto"
      },
      "regularPath": "/_posts/%E5%8F%82%E8%80%83%E6%96%87%E6%A1%A3/git-flow.html",
      "relativePath": "_posts/参考文档/git-flow.md",
      "key": "v-f4124298",
      "path": "/pages/6ff370/",
      "headers": [
        {
          "level": 2,
          "title": "什么是 git-flow？",
          "slug": "什么是-git-flow"
        },
        {
          "level": 2,
          "title": "安装 git-flow",
          "slug": "安装-git-flow"
        },
        {
          "level": 2,
          "title": "在项目中设置 git-flow",
          "slug": "在项目中设置-git-flow"
        },
        {
          "level": 2,
          "title": "分支的模式",
          "slug": "分支的模式"
        },
        {
          "level": 2,
          "title": "功能开发",
          "slug": "功能开发"
        },
        {
          "level": 3,
          "title": "开始新功能",
          "slug": "开始新功能"
        },
        {
          "level": 3,
          "title": "完成一个功能",
          "slug": "完成一个功能"
        },
        {
          "level": 2,
          "title": "管理 releases",
          "slug": "管理-releases"
        },
        {
          "level": 3,
          "title": "创建 release",
          "slug": "创建-release"
        },
        {
          "level": 3,
          "title": "完成 release",
          "slug": "完成-release"
        },
        {
          "level": 2,
          "title": "hotfix",
          "slug": "hotfix"
        },
        {
          "level": 3,
          "title": "创建 Hotfixes",
          "slug": "创建-hotfixes"
        },
        {
          "level": 3,
          "title": "完成 Hotfixes",
          "slug": "完成-hotfixes"
        },
        {
          "level": 2,
          "title": "回顾一下",
          "slug": "回顾一下"
        }
      ]
    },
    {
      "title": "Git 常用命令与配置",
      "frontmatter": {
        "title": "Git 常用命令与配置",
        "date": "-",
        "tags": [
          "git"
        ],
        "permalink": "/pages/7edbe3/",
        "categories": [
          "参考文档"
        ],
        "sidebar": "auto"
      },
      "regularPath": "/_posts/%E5%8F%82%E8%80%83%E6%96%87%E6%A1%A3/git.html",
      "relativePath": "_posts/参考文档/git.md",
      "key": "v-e8fb1fe4",
      "path": "/pages/7edbe3/",
      "headers": [
        {
          "level": 2,
          "title": "仓库相关命令",
          "slug": "仓库相关命令"
        },
        {
          "level": 2,
          "title": "回滚相关命令",
          "slug": "回滚相关命令"
        },
        {
          "level": 2,
          "title": "分支相关命令",
          "slug": "分支相关命令"
        },
        {
          "level": 2,
          "title": "tag相关命令",
          "slug": "tag相关命令"
        },
        {
          "level": 2,
          "title": "子模块(submodule)相关命令",
          "slug": "子模块-submodule-相关命令"
        },
        {
          "level": 2,
          "title": "log",
          "slug": "log"
        },
        {
          "level": 2,
          "title": "忽略文件",
          "slug": "忽略文件"
        },
        {
          "level": 2,
          "title": "配置",
          "slug": "配置"
        },
        {
          "level": 2,
          "title": "设置代理",
          "slug": "设置代理"
        }
      ]
    },
    {
      "title": "向 github 开源项目提交 PR 流程",
      "frontmatter": {
        "title": "向 github 开源项目提交 PR 流程",
        "date": "-",
        "tags": [
          "git",
          "github"
        ],
        "permalink": "/pages/f94a96/",
        "categories": [
          "参考文档"
        ],
        "sidebar": "auto"
      },
      "regularPath": "/_posts/%E5%8F%82%E8%80%83%E6%96%87%E6%A1%A3/github-pr.html",
      "relativePath": "_posts/参考文档/github-pr.md",
      "key": "v-69cf1cce",
      "path": "/pages/f94a96/"
    },
    {
      "title": "升级idea 2020.1后闪退",
      "frontmatter": {
        "title": "升级idea 2020.1后闪退",
        "date": "-",
        "tags": [
          "idea"
        ],
        "permalink": "/pages/1d70fc/",
        "categories": [
          "参考文档"
        ],
        "sidebar": false
      },
      "regularPath": "/_posts/%E5%8F%82%E8%80%83%E6%96%87%E6%A1%A3/idea-2020.1-crash.html",
      "relativePath": "_posts/参考文档/idea-2020.1-crash.md",
      "key": "v-45aeae6e",
      "path": "/pages/1d70fc/"
    },
    {
      "title": "macbook pro 装机软件&工具清单",
      "frontmatter": {
        "title": "macbook pro 装机软件&工具清单",
        "date": "-",
        "tags": [
          "posts"
        ],
        "permalink": "/pages/8cb7a9/",
        "categories": [
          "参考文档"
        ],
        "sidebar": false
      },
      "regularPath": "/_posts/%E5%8F%82%E8%80%83%E6%96%87%E6%A1%A3/mac-app-tools-list.html",
      "relativePath": "_posts/参考文档/mac-app-tools-list.md",
      "key": "v-3f299912",
      "path": "/pages/8cb7a9/",
      "headers": [
        {
          "level": 2,
          "title": "app",
          "slug": "app"
        },
        {
          "level": 2,
          "title": "cli",
          "slug": "cli"
        },
        {
          "level": 2,
          "title": "brew cask",
          "slug": "brew-cask"
        },
        {
          "level": 2,
          "title": "brew",
          "slug": "brew"
        },
        {
          "level": 2,
          "title": "opt",
          "slug": "opt"
        }
      ]
    },
    {
      "title": "Mac 键盘快捷键",
      "frontmatter": {
        "title": "Mac 键盘快捷键",
        "date": "-",
        "tags": [
          "mac"
        ],
        "permalink": "/pages/a1d738/",
        "categories": [
          "参考文档"
        ],
        "sidebar": false
      },
      "regularPath": "/_posts/%E5%8F%82%E8%80%83%E6%96%87%E6%A1%A3/mac-keymap.html",
      "relativePath": "_posts/参考文档/mac-keymap.md",
      "key": "v-7c8c7950",
      "path": "/pages/a1d738/",
      "headers": [
        {
          "level": 2,
          "title": "按键符号对照",
          "slug": "按键符号对照"
        },
        {
          "level": 2,
          "title": "剪切、拷贝、粘贴和其他常用快捷键",
          "slug": "剪切、拷贝、粘贴和其他常用快捷键"
        },
        {
          "level": 2,
          "title": "访达和系统快捷键",
          "slug": "访达和系统快捷键"
        },
        {
          "level": 2,
          "title": "文稿快捷键",
          "slug": "文稿快捷键"
        }
      ]
    },
    {
      "title": "mac使用supervisor",
      "frontmatter": {
        "title": "mac使用supervisor",
        "date": "-",
        "tags": [
          "mac",
          "supervisor"
        ],
        "permalink": "/pages/4174de/",
        "categories": [
          "参考文档"
        ],
        "sidebar": false
      },
      "regularPath": "/_posts/%E5%8F%82%E8%80%83%E6%96%87%E6%A1%A3/mac-supervisor.html",
      "relativePath": "_posts/参考文档/mac-supervisor.md",
      "key": "v-e529898c",
      "path": "/pages/4174de/"
    },
    {
      "title": "manjaro-install-docker",
      "frontmatter": {
        "title": "manjaro-install-docker",
        "date": "-",
        "permalink": "/pages/19a763/",
        "categories": [
          "参考文档"
        ],
        "tags": [
          "docker"
        ],
        "sidebar": "auto"
      },
      "regularPath": "/_posts/%E5%8F%82%E8%80%83%E6%96%87%E6%A1%A3/manjaro-install-docker.html",
      "relativePath": "_posts/参考文档/manjaro-install-docker.md",
      "key": "v-6a0b9224",
      "path": "/pages/19a763/",
      "headers": [
        {
          "level": 2,
          "title": "install",
          "slug": "install"
        }
      ]
    },
    {
      "title": "manjaro安装MySQL",
      "frontmatter": {
        "title": "manjaro安装MySQL",
        "date": "-",
        "tags": [
          "manjaro",
          "mysql"
        ],
        "permalink": "/pages/ddd66b/",
        "categories": [
          "参考文档"
        ],
        "sidebar": false
      },
      "regularPath": "/_posts/%E5%8F%82%E8%80%83%E6%96%87%E6%A1%A3/manjaro-install-mysql.html",
      "relativePath": "_posts/参考文档/manjaro-install-mysql.md",
      "key": "v-0e7a7aae",
      "path": "/pages/ddd66b/"
    },
    {
      "title": "nodejs 开发跨平台 cli 工具",
      "frontmatter": {
        "title": "nodejs 开发跨平台 cli 工具",
        "date": "-",
        "permalink": "/pages/64b9b4/",
        "categories": [
          "参考文档"
        ],
        "tags": [
          "nodejs",
          "cli"
        ],
        "sidebar": "auto"
      },
      "regularPath": "/_posts/%E5%8F%82%E8%80%83%E6%96%87%E6%A1%A3/node-cli.html",
      "relativePath": "_posts/参考文档/node-cli.md",
      "key": "v-05b7089c",
      "path": "/pages/64b9b4/",
      "headers": [
        {
          "level": 2,
          "title": "如何运行一个 nodejs 脚本",
          "slug": "如何运行一个-nodejs-脚本"
        },
        {
          "level": 3,
          "title": "版本1",
          "slug": "版本1"
        },
        {
          "level": 3,
          "title": "版本2",
          "slug": "版本2"
        },
        {
          "level": 2,
          "title": "工程化开发",
          "slug": "工程化开发"
        },
        {
          "level": 2,
          "title": "基础框架设计",
          "slug": "基础框架设计"
        },
        {
          "level": 2,
          "title": "打包&安装",
          "slug": "打包-安装"
        },
        {
          "level": 3,
          "title": "通过 npm 全局安装",
          "slug": "通过-npm-全局安装"
        },
        {
          "level": 3,
          "title": "打包可执行文件",
          "slug": "打包可执行文件"
        }
      ]
    },
    {
      "title": "npm -> yarn命令对照",
      "frontmatter": {
        "title": "npm -> yarn命令对照",
        "date": "-",
        "permalink": "/pages/25e556/",
        "tags": [
          "npm",
          "yarn"
        ],
        "categories": [
          "参考文档"
        ],
        "sidebar": "auto"
      },
      "regularPath": "/_posts/%E5%8F%82%E8%80%83%E6%96%87%E6%A1%A3/npm-yarn.html",
      "relativePath": "_posts/参考文档/npm-yarn.md",
      "key": "v-225ee0ba",
      "path": "/pages/25e556/"
    },
    {
      "title": "\\\\\\\\r command not found 解决办法",
      "frontmatter": {
        "title": "\\\\\\\\r command not found 解决办法",
        "date": "-",
        "tags": [
          "linux"
        ],
        "permalink": "/pages/feb83a/",
        "categories": [
          "参考文档"
        ],
        "sidebar": "auto"
      },
      "regularPath": "/_posts/%E5%8F%82%E8%80%83%E6%96%87%E6%A1%A3/shell-command-not-found.html",
      "relativePath": "_posts/参考文档/shell-command-not-found.md",
      "key": "v-70572fee",
      "path": "/pages/feb83a/"
    },
    {
      "title": "ubuntu 使用 rinetd 配置端口转发",
      "frontmatter": {
        "title": "ubuntu 使用 rinetd 配置端口转发",
        "date": "-",
        "permalink": "/pages/87e2c8/",
        "sidebar": "auto",
        "categories": [
          "参考文档"
        ],
        "tags": [
          "端口转发"
        ]
      },
      "regularPath": "/_posts/%E5%8F%82%E8%80%83%E6%96%87%E6%A1%A3/ubuntu-rinetd.html",
      "relativePath": "_posts/参考文档/ubuntu-rinetd.md",
      "key": "v-1fb0c664",
      "path": "/pages/87e2c8/",
      "headers": [
        {
          "level": 3,
          "title": "安装",
          "slug": "安装"
        },
        {
          "level": 3,
          "title": "转发配置",
          "slug": "转发配置"
        },
        {
          "level": 3,
          "title": "重新加载",
          "slug": "重新加载"
        }
      ]
    },
    {
      "title": "ubuntu下彻底卸载LibreOffice方法",
      "frontmatter": {
        "title": "ubuntu下彻底卸载LibreOffice方法",
        "date": "-",
        "tags": [
          "ubuntu",
          "随笔"
        ],
        "permalink": "/pages/fdfa98/",
        "categories": [
          "参考文档"
        ],
        "sidebar": "auto"
      },
      "regularPath": "/_posts/%E5%8F%82%E8%80%83%E6%96%87%E6%A1%A3/ubuntu-uninstall-libreoffice.html",
      "relativePath": "_posts/参考文档/ubuntu-uninstall-libreoffice.md",
      "key": "v-207c3900",
      "path": "/pages/fdfa98/"
    },
    {
      "title": "提问的智慧",
      "frontmatter": {
        "title": "提问的智慧",
        "date": "-",
        "permalink": "/pages/f3a809/",
        "categories": [
          "随笔"
        ],
        "sidebar": "auto",
        "tags": [
          null
        ]
      },
      "regularPath": "/_posts/%E9%9A%8F%E7%AC%94/How-To-Ask-Questions-The-Smart-Way.html",
      "relativePath": "_posts/随笔/How-To-Ask-Questions-The-Smart-Way.md",
      "key": "v-76c45419",
      "path": "/pages/f3a809/",
      "headers": [
        {
          "level": 2,
          "title": "原文版本历史",
          "slug": "原文版本历史"
        },
        {
          "level": 2,
          "title": "声明",
          "slug": "声明"
        },
        {
          "level": 2,
          "title": "简介",
          "slug": "简介"
        },
        {
          "level": 2,
          "title": "在提问之前",
          "slug": "在提问之前"
        },
        {
          "level": 2,
          "title": "当你提问时",
          "slug": "当你提问时"
        },
        {
          "level": 3,
          "title": "慎选提问的论坛",
          "slug": "慎选提问的论坛"
        },
        {
          "level": 3,
          "title": "Stack Overflow",
          "slug": "stack-overflow"
        },
        {
          "level": 3,
          "title": "网站和 IRC 论坛",
          "slug": "网站和-irc-论坛"
        },
        {
          "level": 3,
          "title": "第二步，使用项目邮件列表",
          "slug": "第二步-使用项目邮件列表"
        },
        {
          "level": 3,
          "title": "使用有意义且描述明确的标题",
          "slug": "使用有意义且描述明确的标题"
        },
        {
          "level": 3,
          "title": "使问题容易回复",
          "slug": "使问题容易回复"
        },
        {
          "level": 3,
          "title": "用清晰、正确、精准并语法正确的语句",
          "slug": "用清晰、正确、精准并语法正确的语句"
        },
        {
          "level": 3,
          "title": "使用易于读取且标准的文件格式发送问题",
          "slug": "使用易于读取且标准的文件格式发送问题"
        },
        {
          "level": 3,
          "title": "精确的描述问题并言之有物",
          "slug": "精确的描述问题并言之有物"
        },
        {
          "level": 3,
          "title": "话不在多而在精",
          "slug": "话不在多而在精"
        },
        {
          "level": 3,
          "title": "别动辄声称找到 Bug",
          "slug": "别动辄声称找到-bug"
        },
        {
          "level": 3,
          "title": "低声下气不能代替你的功课",
          "slug": "低声下气不能代替你的功课"
        },
        {
          "level": 3,
          "title": "描述问题症状而非你的猜测",
          "slug": "描述问题症状而非你的猜测"
        },
        {
          "level": 3,
          "title": "按发生时间先后列出问题症状",
          "slug": "按发生时间先后列出问题症状"
        },
        {
          "level": 3,
          "title": "描述目标而不是过程",
          "slug": "描述目标而不是过程"
        },
        {
          "level": 3,
          "title": "别要求使用私人电邮回复",
          "slug": "别要求使用私人电邮回复"
        },
        {
          "level": 3,
          "title": "清楚明确的表达你的问题以及需求",
          "slug": "清楚明确的表达你的问题以及需求"
        },
        {
          "level": 3,
          "title": "询问有关代码的问题时",
          "slug": "询问有关代码的问题时"
        },
        {
          "level": 3,
          "title": "别把自己家庭作业的问题贴上来",
          "slug": "别把自己家庭作业的问题贴上来"
        },
        {
          "level": 3,
          "title": "去掉无意义的提问句",
          "slug": "去掉无意义的提问句"
        },
        {
          "level": 3,
          "title": "即使你很急也不要在标题写`紧急`",
          "slug": "即使你很急也不要在标题写紧急"
        }
      ]
    },
    {
      "title": "归档",
      "frontmatter": {
        "archivesPage": true,
        "title": "归档",
        "permalink": "/archives/",
        "article": false
      },
      "regularPath": "/@pages/archivesPage.html",
      "relativePath": "@pages/archivesPage.md",
      "key": "v-c5a5552a",
      "path": "/archives/"
    },
    {
      "title": "分类",
      "frontmatter": {
        "categoriesPage": true,
        "title": "分类",
        "permalink": "/categories/",
        "article": false
      },
      "regularPath": "/@pages/categoriesPage.html",
      "relativePath": "@pages/categoriesPage.md",
      "key": "v-5eddedcb",
      "path": "/categories/"
    },
    {
      "title": "标签",
      "frontmatter": {
        "tagsPage": true,
        "title": "标签",
        "permalink": "/tags/",
        "article": false
      },
      "regularPath": "/@pages/tagsPage.html",
      "relativePath": "@pages/tagsPage.md",
      "key": "v-14d3fe2a",
      "path": "/tags/"
    },
    {
      "title": "Home",
      "frontmatter": {
        "home": true,
        "bannerBg": "/bg1.jpg",
        "features": null,
        "postList": "detailed",
        "simplePostListLength": 15
      },
      "regularPath": "/",
      "relativePath": "index.md",
      "key": "v-3e486ff8",
      "path": "/"
    }
  ],
  "themeConfig": {
    "sidebarDepth": 2,
    "mode": "light",
    "summary": false,
    "smoothScroll": true,
    "logo": "/avatar.jpg",
    "search": true,
    "searchMaxSuggestions": 10,
    "sidebar": {
      "/01.收藏/": [
        [
          "01.awesome.md",
          "开源项目、博客、书籍整理",
          "/awesome"
        ]
      ],
      "catalogue": {},
      "/02.go/": [
        [
          "01.README.md",
          "golang 入门学习指南",
          "/go"
        ],
        {
          "title": "go-kit",
          "collapsable": true,
          "children": [
            [
              "10.go-kit/01.quickstart.md",
              "go-kit学习指南 - 基础概念和架构",
              "/pages/40737e/"
            ],
            [
              "10.go-kit/02.protocol-support.md",
              "go-kit学习指南 - 多协议支持",
              "/pages/efb886/"
            ],
            [
              "10.go-kit/03.middleware.md",
              "go-kit学习指南 - 中间件",
              "/pages/d6f092/"
            ],
            [
              "10.go-kit/04.discovery.md",
              "go-kit开发微服务 - 服务注册与发现",
              "/pages/a15528/"
            ]
          ]
        }
      ],
      "/03.java/": [
        [
          "01.README.md",
          "java api 文档",
          "/java"
        ],
        {
          "title": "版本特性",
          "collapsable": true,
          "children": [
            {
              "title": "java8",
              "collapsable": true,
              "children": [
                [
                  "10.版本特性/01.java8/01.lambda-function.md",
                  "Lambda表达式与函数式接口",
                  "/pages/581190/"
                ],
                [
                  "10.版本特性/01.java8/02.date.md",
                  "新的Date&Time API",
                  "/pages/8a3a67/"
                ],
                [
                  "10.版本特性/01.java8/03.method-ref.md",
                  "方法引用",
                  "/pages/94fd66/"
                ],
                [
                  "10.版本特性/01.java8/04.stream.md",
                  "Stream（流）",
                  "/pages/1a3449/"
                ],
                [
                  "10.版本特性/01.java8/05.optional.md",
                  "optional",
                  "/pages/191279/"
                ]
              ]
            }
          ]
        },
        {
          "title": "jvm",
          "collapsable": true,
          "children": [
            [
              "20.jvm/01.jvm.md",
              "JVM 结构体系",
              "/pages/fc50f5/"
            ],
            [
              "20.jvm/02.jvm-runtime-data-area.md",
              "JVM 内存区域划分",
              "/pages/9e1ec7/"
            ],
            [
              "20.jvm/03.gc.md",
              "JVM 垃圾收集",
              "/pages/57792d/"
            ],
            [
              "20.jvm/04.jvm-option.md",
              "JVM 参数配置",
              "/pages/eeb95f/"
            ],
            [
              "20.jvm/05.tools.md",
              "JVM 监控分析工具",
              "/pages/d0ff21/"
            ],
            [
              "20.jvm/07.class-loader.md",
              "JVM 类加载器过程",
              "/pages/2204ba/"
            ],
            [
              "20.jvm/100.hot-reload.md",
              "自己动手写一个 java 热加载插件",
              "/pages/86ec0a/"
            ]
          ]
        },
        {
          "title": "网络编程",
          "collapsable": true,
          "children": [
            [
              "30.网络编程/01.java-io.md",
              "Java IO",
              "/pages/129a86/"
            ],
            [
              "30.网络编程/02.netty.md",
              "netty介绍",
              "/pages/32a147/"
            ]
          ]
        },
        {
          "title": "并发编程",
          "collapsable": true,
          "children": [
            [
              "40.并发编程/01.index.md",
              "并发编程三大特性",
              "/pages/669a06/"
            ],
            [
              "40.并发编程/02.thread-Introduction.md",
              "线程的基本概念",
              "/pages/0b1de7/"
            ],
            [
              "40.并发编程/03.thread-stop.md",
              "如何正确停止一个线程",
              "/pages/4f57d7/"
            ],
            [
              "40.并发编程/04.thread-pool.md",
              "java线程池",
              "/pages/5f2440/"
            ],
            [
              "40.并发编程/05.thread-pool-size.md",
              "线程池大小设置多少合适",
              "/pages/335338/"
            ],
            [
              "40.并发编程/06.queue.md",
              "java 常用队列",
              "/pages/2c5d93/"
            ],
            [
              "40.并发编程/07.limit.md",
              "使用 Semaphore 实现一个简单限流器",
              "/pages/b4b97e/"
            ]
          ]
        }
      ],
      "/08.架构/": [
        {
          "title": "概览",
          "collapsable": true,
          "children": [
            [
              "01.概览/01.README.md",
              "服务端架构技能图谱",
              "/architect"
            ]
          ]
        },
        {
          "title": "设计模式",
          "collapsable": true,
          "children": [
            [
              "05.设计模式/01.README.md",
              "软件设计原则",
              "/pages/11981c/"
            ],
            {
              "title": "创建型",
              "collapsable": true,
              "children": [
                [
                  "05.设计模式/02.创建型/10.singleton.md",
                  "单例模式",
                  "/pages/0c5862/"
                ],
                [
                  "05.设计模式/02.创建型/11.factory.md",
                  "工厂模式",
                  "/pages/963fa5/"
                ]
              ]
            },
            {
              "title": "结构型",
              "collapsable": true,
              "children": [
                [
                  "05.设计模式/03.结构型/12.decorator.md",
                  "装饰器模式",
                  "/pages/d36eab/"
                ],
                [
                  "05.设计模式/03.结构型/13.delegation.md",
                  "委派模式",
                  "/pages/4c6784/"
                ],
                [
                  "05.设计模式/03.结构型/14.proxy.md",
                  "代理模式",
                  "/pages/5a8d03/"
                ]
              ]
            },
            {
              "title": "行为型",
              "collapsable": true,
              "children": [
                [
                  "05.设计模式/04.行为型/20.observer.md",
                  "观察者模式",
                  "/pages/782922/"
                ],
                [
                  "05.设计模式/04.行为型/21.template.md",
                  "模板方法",
                  "/pages/341eba/"
                ],
                [
                  "05.设计模式/04.行为型/22.strategy.md",
                  "策略模式",
                  "/pages/1ddae1/"
                ]
              ]
            }
          ]
        },
        {
          "title": "性能优化",
          "collapsable": true,
          "children": [
            {
              "title": "性能测试工具",
              "collapsable": true,
              "children": [
                [
                  "20.性能优化/00.性能测试工具/01.wrk.md",
                  "性能测试神器 wrk 使用教程",
                  "/wrk"
                ]
              ]
            },
            [
              "20.性能优化/01.tomcat-performance.md",
              "tomcat 性能优化",
              "/pages/419c0e/"
            ]
          ]
        },
        {
          "title": "分布式",
          "collapsable": true,
          "children": [
            {
              "title": "zookeeper",
              "collapsable": true,
              "children": [
                [
                  "30.分布式/04.zookeeper/01.README.md",
                  "zookeeper介绍",
                  "/pages/c998ad/"
                ],
                [
                  "30.分布式/04.zookeeper/02.case.md",
                  "zookeeper经典使用场景",
                  "/pages/d77b23/"
                ]
              ]
            }
          ]
        },
        {
          "title": "网关",
          "collapsable": true,
          "children": [
            {
              "title": "openresty",
              "collapsable": true,
              "children": [
                [
                  "40.网关/01.openresty/01.gateway.md",
                  "OpenResty从入门到开发一个网关服务",
                  "/openresty/gateway"
                ],
                [
                  "40.网关/01.openresty/02.test-nginx.md",
                  "openresty 测试框架 test::nginx 安装",
                  "/pages/5bffac/"
                ]
              ]
            }
          ]
        },
        {
          "title": "流量治理",
          "collapsable": true,
          "children": [
            [
              "50.流量治理/01.sentinel-dashboard-apollo.md",
              "不改一行源码，实现 sentinel-dashboard 所有配置支持 apollo 持久化",
              "/sentinel-dashboard-apollo"
            ],
            [
              "50.流量治理/02.sentinel-dashboard-apollo-wiki.md",
              "sentinel-dashboard-apollo 使用",
              "/sentinel-dashboard-apollo-wiki"
            ]
          ]
        },
        {
          "title": "数据治理",
          "collapsable": true,
          "children": [
            [
              "60.数据治理/05.mysql数据同步方案-canal高可用部署.md",
              "MySQL 异构数据同步方案 - canal 高可用部署",
              "/pages/62b861/"
            ]
          ]
        },
        {
          "title": "云原生",
          "collapsable": true,
          "children": [
            [
              "100.云原生/01.k8s-install.md",
              "ubuntu 安装 Kubernetes",
              "/pages/2ea024/"
            ],
            [
              "100.云原生/02.k8s-dashboard-install.md",
              "安装 kubernetes-dashboard",
              "/pages/4d24b0/"
            ]
          ]
        }
      ],
      "/09.book/": [
        {
          "title": "java",
          "collapsable": true,
          "children": [
            [
              "01.java/01.alibaba-java-manual.md",
              "Java开发手册-嵩山版",
              "/book/java/alibaba-java-manual"
            ],
            [
              "01.java/02.effective-java-3.md",
              "effective-java 第三版",
              "/book/java/effective-java-3"
            ],
            [
              "01.java/03.refactor.md",
              "重构-改善既有代码的设计",
              "/book/java/refactor"
            ],
            [
              "01.java/04.google-guava.md",
              "Google Guava官方教程",
              "/book/java/google-guava"
            ],
            [
              "01.java/05.inside in-jvm.md",
              "深入理解Java虚拟机-第3版",
              "/book/java/inside-in-jvm"
            ]
          ]
        },
        {
          "title": "nginx",
          "collapsable": true,
          "children": [
            [
              "02.nginx/01.nginx.md",
              "nginx 文档",
              "/book/nginx"
            ],
            [
              "02.nginx/02.openresty.md",
              "OpenResty 最佳实践",
              "/book/nginx/openresty"
            ],
            [
              "02.nginx/03.agentzh-nginx.md",
              "agentzh 的 Nginx 教程",
              "/book/nginx/agentzh-nginx"
            ]
          ]
        },
        {
          "title": "security",
          "collapsable": true,
          "children": [
            [
              "03.security/01.web-hacking-tech-revealed.md",
              "web前端黑客技术揭秘",
              "/book/security/web-hacking-tech-revealed"
            ],
            [
              "03.security/02.white-hat-web-security.md",
              "白帽子讲Web安全",
              "/book/security/white-hat-web-security"
            ]
          ]
        },
        {
          "title": "sre",
          "collapsable": true,
          "children": [
            [
              "04.sre/01.linux-cmd.md",
              "Linux 命令大全完整版",
              "/book/sre/linux-cmd"
            ],
            [
              "04.sre/02.shellbook.md",
              "shell 编程范例",
              "/book/sre/shellbook"
            ],
            [
              "04.sre/03.vbird-linux-basic-4.md",
              "鸟哥的Linux私房菜-基础篇-第四版",
              "/book/sre/vbird-linux-basic-4"
            ]
          ]
        }
      ],
      "/10.数据库/": [
        {
          "title": "mysql",
          "collapsable": true,
          "children": [
            [
              "01.mysql/01.InnoDB.md",
              "MySQL-InnoDB 存储引擎概述",
              "/pages/8f6be4/"
            ],
            [
              "01.mysql/02.mysql-index.md",
              "MySql 索引",
              "/pages/fc05b5/"
            ],
            [
              "01.mysql/03.transaction.md",
              "MySql 事务",
              "/pages/e4f078/"
            ],
            [
              "01.mysql/04.log.md",
              "MySql 日志系统（WAL）",
              "/pages/0e45e4/"
            ],
            [
              "01.mysql/05.order-by.md",
              "MySql order by 的执行过程与优化",
              "/pages/9239fb/"
            ],
            [
              "01.mysql/06.performance.md",
              "MySQL 性能分析与常见性能问题总结",
              "/pages/3ce3c6/"
            ],
            [
              "01.mysql/08.specification.md",
              "mysql推荐使用规范",
              "/pages/58ee1f/"
            ],
            [
              "01.mysql/09.options.md",
              "MySQL 常用配置整理",
              "/pages/744ea9/"
            ],
            [
              "01.mysql/10.cmd.md",
              "mysql常用命令整理",
              "/pages/1af172/"
            ],
            [
              "01.mysql/20.mycli.md",
              "mycli-强大的MySQL命令行客户端",
              "/pages/9ecfb4/"
            ]
          ]
        },
        {
          "title": "redis",
          "collapsable": true,
          "children": [
            [
              "02.redis/00.redis-kv-rehash.md",
              "redis key-value 存储结构及扩容",
              "/pages/b30316/"
            ],
            [
              "02.redis/01.redis-structure.md",
              "redis 数据类型对应的数据结构",
              "/pages/7d45f8/"
            ],
            [
              "02.redis/02.redis-persistence.md",
              "redis 数据持久化",
              "/pages/81a37c/"
            ]
          ]
        }
      ],
      "/100.其他/": [
        {
          "title": "linux",
          "collapsable": true,
          "children": [
            [
              "01.linux/01.bash.md",
              "常用 shell 脚本样例",
              "/pages/95c88a/"
            ]
          ]
        },
        {
          "title": "tools",
          "collapsable": true,
          "children": [
            [
              "02.tools/01.idea.md",
              "idea",
              "/pages/019efa/"
            ]
          ]
        }
      ],
      "/20.alg/": [
        [
          "02.lru-cache.md",
          "常用算法 - lru cache",
          "/alg/lru-cache"
        ]
      ],
      "/50.关于/": [
        [
          "01.about.md",
          "关于",
          "/about"
        ]
      ],
      "/51.链接/": [
        [
          "01.links.md",
          "链接",
          "/links"
        ]
      ]
    },
    "authorAvatar": "/avatar.jpg",
    "isShowComments": true,
    "nav": [
      {
        "text": "首页",
        "link": "/"
      },
      {
        "text": "收藏",
        "link": "/awesome/"
      },
      {
        "text": "golang",
        "link": "/go/"
      },
      {
        "text": "java",
        "link": "/java/"
      },
      {
        "text": "架构之路",
        "link": "/architect/"
      },
      {
        "text": "常用算法",
        "link": "/alg/lru-cache/"
      },
      {
        "text": "书单",
        "icon": "bi-book",
        "items": [
          {
            "text": "Java",
            "icon": "co-java",
            "link": "/book/java/alibaba-java-manual/"
          },
          {
            "text": "nginx",
            "icon": "co-nginx",
            "link": "/book/nginx/"
          },
          {
            "text": "系统运维",
            "link": "/book/sre/vbird-linux-basic-4/"
          },
          {
            "text": "系统安全",
            "link": "/book/security/white-hat-web-security/"
          }
        ]
      },
      {
        "text": "数据库&缓存",
        "items": [
          {
            "text": "mysql",
            "link": "/pages/8f6be4/"
          },
          {
            "text": "redis",
            "link": "/pages/7d45f8/"
          }
        ]
      },
      {
        "text": "参考文档",
        "link": "/categories/?category=参考文档&#"
      },
      {
        "text": "关于",
        "link": "/about/"
      },
      {
        "text": "链接",
        "link": "/links/"
      },
      {
        "text": "索引",
        "link": "/archives/",
        "items": [
          {
            "text": "分类",
            "link": "/categories/"
          },
          {
            "text": "标签",
            "link": "/tags/"
          },
          {
            "text": "归档",
            "link": "/archives/"
          }
        ]
      }
    ],
    "footer": {
      "createYear": 2016,
      "copyrightInfo": "铁匠 | <a href=\"http://beian.miit.gov.cn/\" target=\"_blank\">粤ICP备15021633号</a>"
    },
    "author": {
      "name": "fengjx",
      "link": "https://github.com/fengjx"
    },
    "blogger": {
      "avatar": "/avatar.jpg",
      "name": "",
      "slogan": "专注、不予评判地关注当下"
    },
    "social": {
      "icons": [
        {
          "iconClass": "icon-youjian",
          "title": "发邮件",
          "link": "mailto:fengjianxin2012@gmail.com"
        },
        {
          "iconClass": "icon-github",
          "title": "GitHub",
          "link": "https://github.com/fengjx"
        },
        {
          "iconClass": "icon-erji",
          "title": "听音乐",
          "link": "https://music.163.com/#/user/home?id=45779822"
        }
      ]
    },
    "friendLink": [
      {
        "title": "美团技术团队",
        "link": "https://tech.meituan.com"
      },
      {
        "title": "蚂蚁金服技术官网",
        "link": "https://www.sofastack.tech/"
      },
      {
        "title": "伯乐在线",
        "link": "https://github.com/jobbole"
      },
      {
        "title": "酷壳",
        "link": "https://coolshell.cn/"
      }
    ],
    "htmlModules": {
      "homeSidebarB": "<div style=\"padding: 0.95rem\">\n    <p style=\"\n      color: var(--textColor);\n      opacity: 0.9;\n      font-size: 20px;\n      font-weight: bold;\n      margin: 0 0 8px 0;\n    \">个人微信</p>\n    <img src=\"/assets/profile/wx.jpg\"  style=\"width:100%;\" />\n    </div>"
    }
  }
}